/* eslint-disable array-callback-return */
import React, { useEffect, useState } from 'react'
import { createSelector } from 'reselect'
import { useSelector, useDispatch } from 'react-redux'
import moment from 'moment'
import './styles.scss'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'

import PropTypes from 'prop-types'
import AppBar from '@material-ui/core/AppBar'

import Typography from '@material-ui/core/Typography'
// import { Alert } from '@material-ui/lab'
import {
  Grid,
  Box,
  TextField,
  MenuItem,
  Tooltip,
  Table,
  TableRow,
  TableCell,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Alert,
  Snackbar,
} from '@mui/material'

import {
  Col,
  Collapse,
  InputNumber,
  Layout,
  Row,
  Space,
  Tabs,
  TreeSelect,
  Checkbox,
  Button,
  Form,
  DatePicker,
  Alert as AntdAlert,
} from 'antd'
// import { DatePicker } from '@mui/x-date-pickers/DatePicker'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import esLocale from 'date-fns/locale/es'
import CurrencyFormat from 'react-currency-format'
import InfoIcon from '@material-ui/icons/Info'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'

//HELPERS
import {
  formatDBDate,
  checkDateIsBetweenRange,
  addArrayItems,
  formatDateToDB,
} from '../../utils/helpers'

//API
import {
  makeSelectSingleExperience,
  makeSelectAgency,
} from '../../redux/ducks/experiences'

import { firebaseDb } from '../../config/firebaseConfig'

import { getScheduleExperience } from '../../services/FirebaseServices/experienceServices'

import {
  checkAvailabilityForResource,
  getAllReservationsForExperience,
  getResourcesByDayAndHour,
  getServiceByDayAndHour,
} from '../../services/FirebaseServices/reservationServices'
import {
  makeSelectStartDate,
  makeSelectEndDate,
  makeSelectGuestAmount,
  makeSelectChildAmount,
  makeSelectTotalPrice,
  makeSelectSingleDate,
  makeSelectExitDate,
  makeSelectTime,
  makeSelectExitTime,
  makeSelectHoursAmount,
  makeSelectExtraPersons,
  makeSelectTimeSelect,
  makeSelectPartialPrice,
  makeSelectAddonsPrice,
  makeSelectAddonsPersonsPrice,
  makeSelectReservationPrice,
  makeSelectSelectedAddons,
  makeSelectHotelHour,
  makeSelectSingleLimit,
  makeSelectGiftCard,
  set_start_date,
  set_end_date,
  set_guest_amount,
  set_child_amount,
  set_total_price,
  set_single_date,
  set_time,
  set_time_select,
  set_hotel_hour,
  set_partial_price,
  set_addons_price,
  set_addons_persons_price,
  set_reservation_price,
  set_selected_addons,
  set_service,
  set_single_limit,
  set_is_gift_card,
  set_hours_amount,
  set_extra_persons,
  set_exit_time,
  set_exit_date,
} from '../../redux/ducks/reservationDetails'
import { border, fontFamily } from '@material-ui/system'
import dayjs from 'dayjs'
import updateLocale from 'dayjs/plugin/updateLocale'
import { DataUsageTwoTone } from '@material-ui/icons'

const stateSelector = createSelector(
  [
    makeSelectStartDate,
    makeSelectEndDate,
    makeSelectSingleExperience,
    makeSelectGuestAmount,
    makeSelectChildAmount,
    makeSelectTotalPrice,
    makeSelectSingleDate,
    makeSelectExitDate,
    makeSelectTime,
    makeSelectExitTime,
    makeSelectHoursAmount,
    makeSelectExtraPersons,
    makeSelectAgency,
    makeSelectTimeSelect,
    makeSelectPartialPrice,
    makeSelectAddonsPrice,
    makeSelectAddonsPersonsPrice,
    makeSelectReservationPrice,
    makeSelectSelectedAddons,
    makeSelectHotelHour,
    makeSelectSingleLimit,
    makeSelectGiftCard,
  ],
  (
    startDate,
    endDate,
    singleExperience,
    guestAmount,
    childAmount,
    totalPrice,
    singleDate,
    exitDate,
    time,
    exitTime,
    hoursAmount,
    extraPersons,
    agency,
    timeSelect,
    partialPrice,
    addonsPrice,
    addonsPersonsPrice,
    reservationPrice,
    selectedAddons,
    hotelHour,
    singleLimit,
    giftCard,
  ) => ({
    startDate,
    endDate,
    singleExperience,
    guestAmount,
    childAmount,
    totalPrice,
    singleDate,
    exitDate,
    time,
    exitTime,
    hoursAmount,
    extraPersons,
    agency,
    timeSelect,
    partialPrice,
    addonsPrice,
    addonsPersonsPrice,
    reservationPrice,
    selectedAddons,
    hotelHour,
    singleLimit,
    giftCard,
  }),
)

const actionDispatch = (dispatch) => ({
  setStartDate: (startDate) => dispatch(set_start_date(startDate)),
  setEndDate: (endDate) => dispatch(set_end_date(endDate)),
  setGuestAmount: (guestAmount) => dispatch(set_guest_amount(guestAmount)),
  setChildAmount: (childAmount) => dispatch(set_child_amount(childAmount)),
  setTotalPrice: (totalPrice) => dispatch(set_total_price(totalPrice)),
  setSingleDate: (singleDate) => dispatch(set_single_date(singleDate)),
  setExitDate: (exitDate) => dispatch(set_exit_date(exitDate)),

  setTime: (time) => dispatch(set_time(time)),
  setExitTime: (exitTime) => dispatch(set_exit_time(exitTime)),

  setHoursAmount: (hoursAmount) => dispatch(set_hours_amount(hoursAmount)),
  setExtraPersons: (extraPersons) => dispatch(set_extra_persons(extraPersons)),

  setTimeSelect: (timeSelect) => dispatch(set_time_select(timeSelect)),
  setHotelHour: (hotelHour) => dispatch(set_hotel_hour(hotelHour)),
  setPartialPrice: (partialPrice) => dispatch(set_partial_price(partialPrice)),
  setAddonsPrice: (addonsPrice) => dispatch(set_addons_price(addonsPrice)),
  setAddonsPersonsPrice: (addonsPersonsPrice) =>
    dispatch(set_addons_persons_price(addonsPersonsPrice)),
  setReservationPrice: (reservationPrice) =>
    dispatch(set_reservation_price(reservationPrice)),
  setSelectedAddons: (selectedAddons) =>
    dispatch(set_selected_addons(selectedAddons)),
  setService: (service) => dispatch(set_service(service)),
  setSingleLimit: (singleLimit) => dispatch(set_single_limit(singleLimit)),
  setIsGiftCard: (giftCard) => dispatch(set_is_gift_card(giftCard)),
})

const ReservationDetailsHotelsPerHours = ({ handleNext, classes, hotDeal }) => {
  const {
    startDate,
    endDate,
    singleExperience,
    guestAmount,
    childAmount,
    singleDate,
    exitDate,
    time,
    hoursAmount,
    extraPersons,
    agency,
    timeSelect,
    partialPrice,
    addonsPrice,
    addonsPersonsPrice,
    reservationPrice,
    selectedAddons,
    giftCard,
  } = useSelector(stateSelector)
  const {
    setStartDate,
    setEndDate,
    setGuestAmount,
    setTotalPrice,
    setChildAmount,
    setSingleDate,
    setExitDate,
    setTime,
    setHoursAmount,
    setExtraPersons,
    setTimeSelect,
    setExitTime,
    setHotelHour,
    setPartialPrice,
    setAddonsPrice,
    setAddonsPersonsPrice,
    setReservationPrice,
    setSelectedAddons,
    setService,
    setIsGiftCard,
  } = actionDispatch(useDispatch())

  const [schedule, setSchedule] = useState({})
  const [isDisableTime, setIsDisableTime] = useState(time ? false : true)
  const [isErrorGuestAmount, setIsErrorGuestAmount] = useState(false)
  const [isErrorChildAmount, setIsErrorChildAmount] = useState(false)
  const [isErrorSingleDate, setIsErrorSingleDate] = useState(false)
  const [isErrorTime, setIsErrorTime] = useState(false)
  const [snackOpen, setSnackOpen] = useState({ isOpen: false, message: '' })
  const [isExperiencesEnded, setIsExperienceEnded] = useState(false)
  const [isServiceBlocked, setIsServiceBlocked] = useState(false)
  const [selectedDate, setSelectedDate] = useState(null)
  const [servicesBlockeds, setServicesBlockeds] = useState([])
  const [isServicesBlocked, setIsServicesBlocked] = useState(false)
  const [timedBlockersAlert, setTimedBlocksAlert] = useState(true)
  const [isAvailableCapacity, setIsAvailableCapacity] = useState(false)
  const [isPreviousDaysOk, setisPreviousDaysOk] = useState(false)
  // const [experienceDisponibility, setExperienceDisponibility] = useState(false)
  const [openSnackBarCapacity, setOpenSnackBarCapacity] = useState(false)
  const [openSnackBarMinDays, setOpenSnackBarMinDays] = useState(false)
  const [reservasPostToday, setReservasPostToday] = useState([])
  const [reservations, setReservations] = useState()
  const [scheduleDays, setScheduleDays] = useState('')

  const [openSnackBar, setOpenSnackBar] = useState(false)
  const [minDateSelect, setMinDateSelect] = useState('')
  const [openTimeSnack, setOpenTimeSnack] = useState(false)
  const [isTimeAvailable, setIsTimeAvailable] = useState(false)
  const [day, setDay] = useState(false)
  const [specificTimes, setSpecificTimes] = useState()
  const [personsPerReserv, setPersonsPerReserv] = useState()
  const [maxPassengers, setMaxPassengers] = useState()
  const [openSnackPassengers, setOpenSnackPassengers] = useState(false)
  const [isPassengersCapacity, setIiPassengersCapacity] = useState(true)
  const [selectedDates, setSelectedDates] = useState([])
  const [daysWithHours, setDaysWithHours] = useState()
  const [initialized, setInitialized] = useState(false)
  const [timeConverted, setTimeConverted] = useState()
  const [timeVisualiz, setTimeVisualiz] = useState()
  const [exitTimeConverted, setExitTimeConverted] = useState()
  const [exitTimeVisualiz, setExitTimeVisualiz] = useState()
  const [onSeasons, setOnSeasons] = useState()
  const [resources, setResources] = useState([])
  const [availabilityInResourceDay, setAvailabilityInResourceDay] = useState([])
  const [availabilityInResourceNextDay, setAvailabilityInResourceNextDay] =
    useState([])

  const [timeSelectExit, setTimeSelectExit] = useState()
  dayjs.extend(updateLocale)
  dayjs.updateLocale('en', {
    weekStart: 1,
  })

  function convertTo24HourFormat(time) {
    let hours = parseInt(time.split(':')[0])
    const minutes = parseInt(time.split(':')[1])

    if (time.includes('PM') && hours !== 12) {
      hours += 12
    } else if (time.includes('AM') && hours === 12) {
      hours = 0
    }

    setTimeConverted(
      hours.toString().padStart(2, '0') +
        ':' +
        minutes.toString().padStart(2, '0'),
    )
    setTime(
      hours.toString().padStart(2, '0') +
        ':' +
        minutes.toString().padStart(2, '0'),
    )
  }

  function convertTo24HourFormatExit(time) {
    let hours = parseInt(time.split(':')[0])
    const minutes = parseInt(time.split(':')[1])

    if (time.includes('PM') && hours !== 12) {
      hours += 12
    } else if (time.includes('AM') && hours === 12) {
      hours = 0
    }

    setExitTimeConverted(
      hours.toString().padStart(2, '0') +
        ':' +
        minutes.toString().padStart(2, '0'),
    )
    setExitTime(
      hours.toString().padStart(2, '0') +
        ':' +
        minutes.toString().padStart(2, '0'),
    )
  }

  useEffect(() => {
    const data = { agencyId: agency.key, experienceId: singleExperience.key }

    async function fetchData() {
      const fetchedResources = await getResourcesByDayAndHour(data)
      setResources(fetchedResources)
    }

    fetchData()
  }, [])

  const getAvailabilityAndFilterHours = async (date) => {
    const data = { agencyId: agency.key }
    const fetchedResources = await checkAvailabilityForResource(
      resources[0]?.id,
      date,
      data,
    )
    setAvailabilityInResourceDay(fetchedResources)
  }

  let treeData = []
  let treeDataExit = []

  // const filterHours= () => {

  const formatTimeData = (time) => {
    const [hour, period] = time.split(':')
    return `${hour.padStart(2, '0')}:${period}`
  }

  function convertTime12to24(time12h) {
    if (typeof time12h === 'string' || time12h instanceof String) {
      const match = time12h.match(/^(\d{1,2}:\d{2})\s?([AP]M)$/i)

      if (!match) {
        throw new Error(
          'Formato de hora no válido. Debe ser en formato "HH:MM AM/PM".',
        )
      }

      const [, time, modifier] = match

      const [hoursStr, minutesStr] = time.split(':')

      let hours = parseInt(hoursStr, 10)
      const minutes = parseInt(minutesStr, 10)

      if (modifier.toUpperCase() === 'PM' && hours < 12) {
        hours += 12
      } else if (modifier.toUpperCase() === 'AM' && hours === 12) {
        hours = 0
      }

      const hours24 = hours.toString().padStart(2, '0')
      const minutes24 = minutes.toString().padStart(2, '0')

      return `${hours24}:${minutes24}`
    } else {
      const match = time12h.value.match(/^(\d{1,2}:\d{2})\s?([AP]M)$/i)

      if (!match) {
        throw new Error(
          'Formato de hora no válido. Debe ser en formato "HH:MM AM/PM".',
        )
      }

      const [, time, modifier] = match

      const [hoursStr, minutesStr] = time.value.split(':')

      let hours = parseInt(hoursStr, 10)
      const minutes = parseInt(minutesStr, 10)

      if (modifier.toUpperCase() === 'PM' && hours < 12) {
        hours += 12
      } else if (modifier.toUpperCase() === 'AM' && hours === 12) {
        hours = 0
      }

      const hours24 = hours.toString().padStart(2, '0')
      const minutes24 = minutes.toString().padStart(2, '0')

      return `${hours24}:${minutes24}`
    }
  }

  const handleDateAndTime = (arraySchedule, date) => {
    const day = date.getDay()
    const filterDay = arraySchedule.days.filter((item) => item.day === day)

    let times = [
      '12:00AM',
      '12:15AM',
      '12:30AM',
      '12:45AM',
      '01:00AM',
      '01:15AM',
      '01:30AM',
      '01:45AM',
      '02:00AM',
      '02:15AM',
      '02:30AM',
      '02:45AM',
      '03:00AM',
      '03:15AM',
      '03:30AM',
      '03:45AM',
      '04:00AM',
      '04:15AM',
      '04:30AM',
      '04:45AM',
      '05:00AM',
      '05:15AM',
      '05:30AM',
      '05:45AM',
      '06:00AM',
      '06:15AM',
      '06:30AM',
      '06:45AM',
      '07:00AM',
      '07:15AM',
      '07:30AM',
      '07:45AM',
      '08:00AM',
      '08:15AM',
      '08:30AM',
      '08:45AM',
      '09:00AM',
      '09:15AM',
      '09:30AM',
      '09:45AM',
      '10:00AM',
      '10:15AM',
      '10:30AM',
      '10:45AM',
      '11:00AM',
      '11:15AM',
      '11:30AM',
      '11:45AM',
      '12:00PM',
      '12:15PM',
      '12:30PM',
      '12:45PM',
      '01:00PM',
      '01:15PM',
      '01:30PM',
      '01:45PM',
      '02:00PM',
      '02:15PM',
      '02:30PM',
      '02:45PM',
      '03:00PM',
      '03:15PM',
      '03:30PM',
      '03:45PM',
      '04:00PM',
      '04:15PM',
      '04:30PM',
      '04:45PM',
      '05:00PM',
      '05:15PM',
      '05:30PM',
      '05:45PM',
      '06:00PM',
      '06:15PM',
      '06:30PM',
      '06:45PM',
      '07:00PM',
      '07:15PM',
      '07:30PM',
      '07:45PM',
      '08:00PM',
      '08:15PM',
      '08:30PM',
      '08:45PM',
      '09:00PM',
      '09:15PM',
      '09:30PM',
      '09:45PM',
      '10:00PM',
      '10:15PM',
      '10:30PM',
      '10:45PM',
      '11:00PM',
      '11:15PM',
      '11:30PM',
      '11:45PM',
    ]

    function mapOrder(array, order) {
      array.sort(function (a, b) {
        var A = a,
          B = b

        if (order.indexOf(A) > order.indexOf(B)) {
          return 1
        } else {
          return -1
        }
      })

      return array
    }

    let ordered_array = mapOrder(filterDay[0].time, times)

    setTimeSelect(ordered_array)
    setIsDisableTime(false)
  }
  const handleDateAndTimeExit = (arraySchedule, date) => {
    const day = date.getDay()
    const filterDay = arraySchedule.days.filter((item) => item.day === day)

    let times = [
      '12:00AM',
      '12:15AM',
      '12:30AM',
      '12:45AM',
      '01:00AM',
      '01:15AM',
      '01:30AM',
      '01:45AM',
      '02:00AM',
      '02:15AM',
      '02:30AM',
      '02:45AM',
      '03:00AM',
      '03:15AM',
      '03:30AM',
      '03:45AM',
      '04:00AM',
      '04:15AM',
      '04:30AM',
      '04:45AM',
      '05:00AM',
      '05:15AM',
      '05:30AM',
      '05:45AM',
      '06:00AM',
      '06:15AM',
      '06:30AM',
      '06:45AM',
      '07:00AM',
      '07:15AM',
      '07:30AM',
      '07:45AM',
      '08:00AM',
      '08:15AM',
      '08:30AM',
      '08:45AM',
      '09:00AM',
      '09:15AM',
      '09:30AM',
      '09:45AM',
      '10:00AM',
      '10:15AM',
      '10:30AM',
      '10:45AM',
      '11:00AM',
      '11:15AM',
      '11:30AM',
      '11:45AM',
      '12:00PM',
      '12:15PM',
      '12:30PM',
      '12:45PM',
      '01:00PM',
      '01:15PM',
      '01:30PM',
      '01:45PM',
      '02:00PM',
      '02:15PM',
      '02:30PM',
      '02:45PM',
      '03:00PM',
      '03:15PM',
      '03:30PM',
      '03:45PM',
      '04:00PM',
      '04:15PM',
      '04:30PM',
      '04:45PM',
      '05:00PM',
      '05:15PM',
      '05:30PM',
      '05:45PM',
      '06:00PM',
      '06:15PM',
      '06:30PM',
      '06:45PM',
      '07:00PM',
      '07:15PM',
      '07:30PM',
      '07:45PM',
      '08:00PM',
      '08:15PM',
      '08:30PM',
      '08:45PM',
      '09:00PM',
      '09:15PM',
      '09:30PM',
      '09:45PM',
      '10:00PM',
      '10:15PM',
      '10:30PM',
      '10:45PM',
      '11:00PM',
      '11:15PM',
      '11:30PM',
      '11:45PM',
    ]

    function mapOrder(array, order) {
      array.sort(function (a, b) {
        var A = a,
          B = b

        if (order.indexOf(A) > order.indexOf(B)) {
          return 1
        } else {
          return -1
        }
      })

      return array
    }

    let ordered_array = mapOrder(filterDay[0].time, times)

    setTimeSelectExit(ordered_array)
    setIsDisableTime(false)
  }
  function separateHoursByDay() {
    const entryHours = []
    const exitHours = []

    const checkin = new Date(availabilityInResourceDay[0].checkinDate)
    const checkout = new Date(availabilityInResourceDay[0].checkoutDate)
    for (const hour of availabilityInResourceDay[0].hourRange) {
      const [hourStr] = hour.split(':')
      const hourNum = parseInt(hourStr, 10)

      if (hourNum <= checkin.getHours()) {
        entryHours.push(hour)
      } else if (hourNum >= checkout.getHours()) {
        exitHours.push(hour)
      }
    }
    return { entryHours, exitHours }
  }
  const getResourceAvailabilityNextDay = async (date) => {
    try {
      const fetchedResources = await checkAvailabilityForResource(
        resources[0].id,
        date,
      )
      setAvailabilityInResourceNextDay(fetchedResources)
      return fetchedResources
    } catch (error) {
      console.error('Error al obtener la disponibilidad de recursos:', error)
      throw error
    }
  }
  const dataTimeSelect = () => {
    if (specificTimes) {
      if (specificTimes instanceof Array) {
        treeData = generateUniqueKeys(
          specificTimes.map((t) => ({ value: t, title: t })),
        )
      } else {
        treeData = generateUniqueKeys([
          { value: specificTimes, title: specificTimes },
        ])
      }
    } else {
      if (availabilityInResourceDay.length > 0) {
        const actualDaySelected = new Date(singleDate)
        const year = actualDaySelected.getFullYear()
        const month = (actualDaySelected.getMonth() + 1)
          .toString()
          .padStart(2, '0')
        const day = actualDaySelected.getDate().toString().padStart(2, '0')
        const formattedDate = `${year}-${month}-${day}`

        const dataTimes = generateUniqueKeys(
          timeSelect.map((t) => ({
            value: convertTime12to24(t),
            title: convertTime12to24(t),
          })),
        )

        const filteredDataTimes = dataTimes.filter((time) => {
          const isInRange = availabilityInResourceDay.some((av) =>
            av.hourRange.includes(time.value),
          )
          return !isInRange
        })

        let finalData = filteredDataTimes.filter((time) => {
          const isFirstHourInRange = availabilityInResourceDay.some(
            (av) => av.hourRange[0] === time.value,
          )
          const isFirstHourPreviousInRange = availabilityInResourceDay.some(
            (av) => {
              const firstHourSplit = av.hourRange[0].split(':')
              const firstHour = parseInt(firstHourSplit[0])
              const currentTimeSplit = time.value.split(':')
              const currentTime = parseInt(currentTimeSplit[0])
              return currentTime === firstHour - 1
            },
          )

          return !isFirstHourInRange && !isFirstHourPreviousInRange
        })
        const actualDateReservation = new Date(singleDate)
        actualDateReservation.setDate(actualDateReservation.getDate() + 1)
        const numberOfDay = actualDateReservation.getDay()
        const dataScheduleNextDay = schedule.days[numberOfDay]
        getResourceAvailabilityNextDay(actualDateReservation)

        const hourVerify = () => {
          for (const resource of availabilityInResourceNextDay) {
            if (
              resource.checkinHour < '12:00' &&
              resource.checkinHour >= '00:00'
            ) {
              return true
            }
          }
          return false
        }
        let resultVerify = hourVerify()
        if (
          dataScheduleNextDay.disponibility === 0 ||
          dataScheduleNextDay.time.length === 0 ||
          resultVerify
        ) {
          finalData = finalData.slice(0, -1)
        }
        treeData = finalData
      } else {
        let data = generateUniqueKeys(
          timeSelect.map((t) => ({
            value: convertTime12to24(t),
            title: convertTime12to24(t),
          })),
        )
        if (data.length < 12) {
          data = data.slice(0, -1)
        }
        treeData = data
      }
    }
  }

  const convertHourToNumber = (hora) => {
    const partes = hora.split(':')
    return parseInt(partes[0]) * 60 + parseInt(partes[1])
  }
  const formatDate = (date) => {
    const day = String(date.getDate()).padStart(2, '0')
    const month = String(date.getMonth() + 1).padStart(2, '0')
    const year = date.getFullYear()
    return `${day}/${month}/${year}`
  }

  function divideTimeBlocksByInterruption(times) {
    let blocks = []
    let currentBlock = []

    for (let i = 0; i < times.length; i++) {
      const currentHour = Number(times[i].value.split(':')[0])
      const previousHour = i > 0 ? Number(times[i - 1].value.split(':')[0]) : -1

      if (i > 0 && currentHour !== previousHour + 1) {
        blocks.push([...currentBlock])
        currentBlock = []
      }
      currentBlock.push(times[i])
    }

    if (currentBlock.length > 0) {
      blocks.push([...currentBlock])
    }

    return blocks
  }
  const dataTimeExitSelect = () => {
    if (specificTimes) {
      if (specificTimes instanceof Array) {
        treeDataExit = generateUniqueKeys(
          specificTimes.map((t) => ({ value: t, title: convertTime12to24(t) })),
        )
      } else {
        treeDataExit = generateUniqueKeys([
          { value: specificTimes, title: specificTimes },
        ])
      }
    } else {
      const actualDaySelected = new Date(singleDate)
      const year = actualDaySelected.getFullYear()
      const month = (actualDaySelected.getMonth() + 1)
        .toString()
        .padStart(2, '0')
      const day = actualDaySelected.getDate().toString().padStart(2, '0')
      const formattedDate = `${year}-${month}-${day}`

      if (availabilityInResourceDay.length > 0) {
        const actualDaySelected = new Date(singleDate)
        const year = actualDaySelected.getFullYear()
        const month = (actualDaySelected.getMonth() + 1)
          .toString()
          .padStart(2, '0')
        const day = actualDaySelected.getDate().toString().padStart(2, '0')
        const formattedDate = `${year}-${month}-${day}`

        const dataTimes = generateUniqueKeys(
          timeSelect.map((t) => ({
            value: convertTime12to24(t),
            title: convertTime12to24(t),
          })),
        )

        const filteredDataTimes = dataTimes.filter((time) => {
          const isInRange = availabilityInResourceDay.some((av) =>
            av.hourRange.includes(time.value),
          )
          return !isInRange
        })
        const timeBlocks = divideTimeBlocksByInterruption(filteredDataTimes)
        let hoursInBlock = []

        for (const obj of timeBlocks) {
          const indexTimeVisualiz = obj.findIndex(
            (hour) => hour.value === timeVisualiz,
          )
          if (indexTimeVisualiz !== -1) {
            hoursInBlock = obj
              .slice(indexTimeVisualiz + 1)
              .map((hour) => hour.value)
            break
          }
        }
        let timesFiltered = generateUniqueKeys(
          hoursInBlock.map((t) => ({ value: t, title: t })),
        )
        const actualDateReservation = new Date(singleDate)
        actualDateReservation.setDate(actualDateReservation.getDate() + 1)
        const numberOfDay = actualDateReservation.getDay()
        const dataScheduleNextDay = schedule.days[numberOfDay]
        let finalData = filteredDataTimes.filter((time) => {
          const isFirstHourInRange = availabilityInResourceDay.some(
            (av) => av.hourRange[0] === time.value,
          )
          const isFirstHourPreviousInRange = availabilityInResourceDay.some(
            (av) => {
              const firstHourSplit = av.hourRange[0].split(':')
              const firstHour = parseInt(firstHourSplit[0])
              const currentTimeSplit = time.value.split(':')
              const currentTime = parseInt(currentTimeSplit[0])
              return currentTime === firstHour - 1
            },
          )
          return !isFirstHourInRange && !isFirstHourPreviousInRange
        })

        const hourVerify = () => {
          for (const resource of availabilityInResourceNextDay) {
            if (
              resource.checkinHour < '12:00' &&
              resource.checkinHour >= '00:00'
            ) {
              return true
            }
          }
          return false
        }
        let resultVerify = hourVerify()
        if (
          dataScheduleNextDay.disponibility === 0 ||
          dataScheduleNextDay.time.length === 0 ||
          resultVerify
        ) {
          treeDataExit = finalData.length - 1
        } else {
          if (timesFiltered.length > 12) {
            timesFiltered = timesFiltered.slice(0, 12)
          } else if (
            dataScheduleNextDay.disponibility > 0 &&
            dataScheduleNextDay.time.length > 0
          ) {
            if (
              timesFiltered.length < 12 &&
              timesFiltered[timesFiltered.length - 1]?.value === '23:00'
            ) {
              const scheduleOfNextDay = timeSelectExit.map((t) =>
                convertTime12to24(t),
              )
              const remainingSlots = 12 - timesFiltered.length
              const hoursRestAddToData = scheduleOfNextDay.slice(
                0,
                remainingSlots,
              )

              const dataNextDate = generateUniqueKeys(
                hoursRestAddToData.map((t) => ({
                  value: t,
                  title: `${t} ${formatDate(actualDateReservation)}`,
                })),
              )
              timesFiltered = [...timesFiltered, ...dataNextDate]
            } else if (!timesFiltered.length) {
              const actualDateReservation = new Date(singleDate)
              actualDateReservation.setDate(actualDateReservation.getDate() + 1)
              const scheduleOfNextDay = timeSelectExit.map((t) =>
                convertTime12to24(t),
              )
              const remainingSlots = 12
              const hoursRestAddToData = scheduleOfNextDay.slice(
                0,
                remainingSlots,
              )

              const dataNextDate = generateUniqueKeys(
                hoursRestAddToData.map((t) => ({
                  value: t,
                  title: `${t} ${formatDate(actualDateReservation)}`,
                })),
              )
              timesFiltered = dataNextDate
            }
          }
        }

        treeDataExit = timesFiltered
      } else if (timeVisualiz) {
        const data = generateUniqueKeys(
          timeSelect.map((t) => ({ value: t, title: t })),
        )
        const restHourFiltered = data.filter((h) => {
          const hourNumber = convertHourToNumber(convertTime12to24(h.value))
          return hourNumber > convertHourToNumber(timeVisualiz)
        })
        let finalData = generateUniqueKeys(
          restHourFiltered.map((t) => ({
            value: convertTime12to24(t.value),
            title: convertTime12to24(t.value),
          })),
        )
        if (finalData.length > 12) {
          finalData = finalData.slice(0, 12)
        } else if (
          finalData.length < 12 &&
          finalData[finalData.length - 1]?.value === '23:00'
        ) {
          const actualDateReservation = new Date(singleDate)
          const actualDateReservationCopy = new Date(singleDate)
          actualDateReservationCopy.setDate(
            actualDateReservationCopy.getDate() + 1,
          )
          const numberOfDay = actualDateReservation.getDay()
          const dataScheduleNextDay = schedule.days[numberOfDay]
          const scheduleOfNextDay = timeSelectExit.map((t) =>
            convertTime12to24(t),
          )
          const remainingSlots = 12 - finalData.length
          const hoursRestAddToData = scheduleOfNextDay.slice(0, remainingSlots)

          const dataNextDate = generateUniqueKeys(
            hoursRestAddToData.map((t) => ({
              value: t,
              title: `${t} ${formatDate(actualDateReservationCopy)}`,
            })),
          )

          getResourceAvailabilityNextDay(actualDateReservationCopy)

          const hourVerify = () => {
            for (const resource of availabilityInResourceNextDay) {
              if (
                resource.checkinHour < '12:00' &&
                resource.checkinHour >= '00:00'
              ) {
                return true
              }
            }
            return false
          }
          let resultVerify = hourVerify()
          if (
            dataScheduleNextDay.disponibility === 0 ||
            dataScheduleNextDay.time.length === 0 ||
            resultVerify
          ) {
            finalData = finalData
          } else {
            finalData = [...finalData, ...dataNextDate]
          }
        } else if (!finalData.length) {
          const actualDateReservationCopy = new Date(singleDate)
          actualDateReservationCopy.setDate(
            actualDateReservationCopy.getDate() + 1,
          )
          const scheduleOfNextDay = timeSelectExit.map((t) =>
            convertTime12to24(t),
          )
          const remainingSlots = 12
          const hoursRestAddToData = scheduleOfNextDay.slice(0, remainingSlots)

          const dataNextDate = generateUniqueKeys(
            hoursRestAddToData.map((t) => ({
              value: t,
              title: `${t} ${formatDate(actualDateReservationCopy)}`,
            })),
          )
          finalData = dataNextDate
        }
        treeDataExit = finalData
      }
    }
  }
  const generateUniqueKeys = (data) => {
    const uniqueKeyMap = new Map()
    return data.map((item) => {
      const key = item.value
      let uniqueKey = key
      let counter = 2

      while (uniqueKeyMap.has(uniqueKey)) {
        uniqueKey = key + counter
        counter++
      }
      uniqueKeyMap.set(uniqueKey, true)
      return { ...item, key: uniqueKey }
    })
  }

  dataTimeSelect()
  function calculateExitDate() {
    const entryDay = singleDate.getDate()
    const entryMonth = singleDate.getMonth() + 1
    const entryYear = singleDate.getFullYear()

    if (
      timeVisualiz >= '12:00' &&
      timeVisualiz <= '23:00' &&
      exitTimeVisualiz >= '00:00' &&
      exitTimeVisualiz <= '12:00'
    ) {
      const nextDay = new Date(singleDate)
      nextDay.setDate(entryDay + 1)
      const exitDay = nextDay.getDate()
      const exitMonth = nextDay.getMonth() + 1
      const exitYear = nextDay.getFullYear()
      setExitDate(
        `${exitDay.toString().padStart(2, '0')}/${exitMonth
          .toString()
          .padStart(2, '0')}/${exitYear}`,
      )
    } else if (timeVisualiz >= '00:00' && exitTimeVisualiz <= '23:00') {
      setExitDate(
        `${entryDay.toString().padStart(2, '0')}/${entryMonth
          .toString()
          .padStart(2, '0')}/${entryYear}`,
      )
    }
  }

  function convert12HourTo24Hour(hora12) {
    const match = hora12.match(/(\d+):(\d+)(\w+)/)
    let horas = parseInt(match[1])
    const periodo = match[3].toLowerCase()

    if (periodo === 'pm' && horas !== 12) {
      horas += 12
    } else if (periodo === 'am' && horas === 12) {
      horas = 0
    }

    return horas
  }

  function calcularTotalHoras(horaEntrada, horaSalida) {
    const horaEntrada24 = convert12HourTo24Hour(horaEntrada)
    const horaSalida24 = convert12HourTo24Hour(horaSalida)

    const diferenciaMinutos = calcularDiferenciaMinutos(
      horaEntrada24,
      horaSalida24,
    )

    const totalHoras = Math.ceil(diferenciaMinutos / 60)
    handlePrice(totalHoras, 'adult')
    return totalHoras
  }

  function convert12HourTo24Hour(hora12) {
    const match = hora12.match(/(\d+):(\d+)(\w+)/)
    let horas = parseInt(match[1])
    const minutos = parseInt(match[2])
    const periodo = match[3].toLowerCase()

    if (periodo === 'pm' && horas !== 12) {
      horas += 12
    } else if (periodo === 'am' && horas === 12) {
      horas = 0
    }

    return horas * 60 + minutos
  }

  function calcularDiferenciaMinutos(horaInicio, horaFin) {
    if (horaInicio <= horaFin) {
      return horaFin - horaInicio
    } else {
      return 24 * 60 - horaInicio + horaFin
    }
  }

  function verifySeasons(date) {
    let onSeasons = { isActive: false, increase: 0 }

    singleExperience.seasons.forEach((season) => {
      const startDate = new Date(season.startDate)
      const endDate = new Date(season.endDate)
      if (date >= startDate && date <= endDate) {
        setOnSeasons({
          isActive: true,
          increase: parseInt(season.increase, 10),
        })
      } else {
        setOnSeasons({ isActive: false, increase: 0 })
      }
    })
  }

  const localeMap = { es: esLocale }
  function mapOrder(array, order) {
    const orderedArray = [...array] // Clonamos el arreglo para no modificar el original

    orderedArray.sort(function (a, b) {
      const A = a
      const B = b

      if (order.indexOf(A) > order.indexOf(B)) {
        return 1
      } else {
        return -1
      }
    })

    return orderedArray
  }

  const checkPxqTable = () => {
    let status = false

    if (singleExperience?.priceQuantity?.length > 0) {
      status = singleExperience?.priceQuantity?.some((p) => {
        return (
          p?.price === 0 ||
          p?.price === '' ||
          p?.from === 0 ||
          p?.from === '' ||
          p?.to === 0 ||
          p?.to === ''
        )
      })
    }

    return status
  }
  const resultPxq = checkPxqTable()

  // function calculateExitTime( ) {
  //   // Convertir el horario de entrada de formato 24 horas a un número entero
  //   const entryHours = parseInt(timeVisualiz.split(':')[0]);
  //   const entryMinutes = parseInt(timeVisualiz.split(':')[1]);

  //   // Calcular el total de minutos de la entrada y la cantidad de horas
  //   const totalMinutes = entryHours * 60 + entryMinutes + hoursAmount * 60;

  //   // Calcular las horas y minutos de salida
  //   const exitHours = Math.floor(totalMinutes / 60) % 24;
  //   const exitMinutes = totalMinutes % 60;

  //   // Calcular el día de salida dependiendo del horario
  //   let exitDate = singleDate;
  //   exitDate.setHours(exitHours);
  //   exitDate.setMinutes(exitMinutes);
  //   if (exitHours < entryHours || (exitHours === entryHours && exitMinutes < entryMinutes)) {
  //     // Si la salida es antes de la entrada, el día de salida es el siguiente día
  //     exitDate.setDate(exitDate.getDate() + 1);
  //   }

  //   // Formatear la hora de salida en formato de 24 horas
  //   const exitTimeFormatted = exitHours.toString().padStart(2, '0') + ':' + exitMinutes.toString().padStart(2, '0');

  //   // Formatear la fecha de salida en formato "DD/MM/YYYY"
  //   const day = exitDate.getDate().toString().padStart(2, '0');
  //   const month = (exitDate.getMonth() + 1).toString().padStart(2, '0');
  //   const year = exitDate.getFullYear().toString();
  //   const exitDateFormatted = `${day}/${month}/${year}`;
  //   setExitTime(exitTimeFormatted)
  //   setExitDate(exitDateFormatted)
  // }

  useEffect(() => {
    addHoursToDates()
  }, [selectedDates])
  useEffect(() => {
    if (
      hotDeal === undefined ||
      hotDeal === null ||
      !hotDeal ||
      Object.keys(hotDeal).length === 0
    ) {
      return null
    } else if (hotDeal && hotDeal?.giftCard?.isGiftCard) {
      setIsGiftCard(true)
      setValue(1)
      ifGiftCardTime()
    }
  }, [])

  useEffect(() => {
    if (hotDeal && singleExperience.partialPercentage === 0) {
      handleGuestAmount(hotDeal.persons, 'adult')

      setSingleDate(new Date(hotDeal.day))
      setSelectedDate(dayjs(hotDeal.day))
      setTime(hotDeal.hour)
    }
  }, [hotDeal, singleExperience])

  useEffect(() => {
    const daysOfWeek = []
    Object.entries(schedule).forEach(([key, value]) => {
      if (key === 'days') {
        daysOfWeek.push(value)
      }
    })
    setScheduleDays(daysOfWeek)
  }, [schedule])

  useEffect(() => {
    const fetchData = async () => {
      const reservations = await getAllReservationsForExperience(
        agency.key,
        singleExperience.key,
      )
      const allReservations = []
      reservations.forEach((r) => {
        if (r.paymentStatus === 'Pago realizado') {
          return allReservations.push(r)
        }
      })
      setReservations(allReservations)
    }

    fetchData()
  }, [])
  useEffect(() => {
    if (reservations && reservations.length > 0) {
      const fechaActual = new Date()
      const allReservations = []
      reservations.forEach((r) => {
        if (r.paymentStatus === 'Pago realizado') {
          return allReservations.push(r)
        }
      })
      const reservasFiltradas = allReservations.filter((reserva) => {
        const fechaReserva = new Date(reserva.day)

        return fechaReserva >= fechaActual
      })
      setReservasPostToday(reservasFiltradas)
    }
  }, [reservations])
  const currentDate = new Date()
  const selectDate = new Date(singleDate)

  function parseTime(timeString) {
    const [time, period] = timeString.split(/([APM]+)/)
    const [hour, minute] = time.split(':').map(Number)
    const isPM = period === 'PM'
    return ((hour % 12) + (isPM ? 12 : 0)) * 60 + minute
  }

  useEffect(() => {
    getScheduleExperience(agency.key, singleExperience.key)
      .then((res) => {
        setSchedule(res)
      })
      .catch((err) => {
        setSnackOpen({
          ...snackOpen,
          isOpen: true,
          message:
            'Hubo un error al realizar su petición. Por favor, intente más tarde.',
        })
      })
  }, [agency.key, singleExperience.key])

  useEffect(() => {
    if (singleDate && schedule && schedule.days) {
      const day = singleDate.getDay()
      const filterDay = schedule.days.find((item) => item.day === day)

      let year = singleDate.getFullYear()
      let month = (singleDate.getMonth() + 1).toString().padStart(2, '0')
      let numberOfDay = singleDate.getDay()
      let dayForm = singleDate.getDate().toString().padStart(2, '0')
      const formatDate = year + '-' + month + '-' + dayForm
      const selectedDay = scheduleDays[0]?.find(
        (day) => day.day === numberOfDay,
      )
      if (filterDay) {
        const times = [
          '12:00AM',
          '12:15AM',
          '12:30AM',
          '12:45AM',
          '01:00AM',
          '01:15AM',
          '01:30AM',
          '01:45AM',
          '02:00AM',
          '02:15AM',
          '02:30AM',
          '02:45AM',
          '03:00AM',
          '03:15AM',
          '03:30AM',
          '03:45AM',
          '04:00AM',
          '04:15AM',
          '04:30AM',
          '04:45AM',
          '05:00AM',
          '05:15AM',
          '05:30AM',
          '05:45AM',
          '06:00AM',
          '06:15AM',
          '06:30AM',
          '06:45AM',
          '07:00AM',
          '07:15AM',
          '07:30AM',
          '07:45AM',
          '08:00AM',
          '08:15AM',
          '08:30AM',
          '08:45AM',
          '09:00AM',
          '09:15AM',
          '09:30AM',
          '09:45AM',
          '10:00AM',
          '10:15AM',
          '10:30AM',
          '10:45AM',
          '11:00AM',
          '11:15AM',
          '11:30AM',
          '11:45AM',
          '12:00PM',
          '12:15PM',
          '12:30PM',
          '12:45PM',
          '01:00PM',
          '01:15PM',
          '01:30PM',
          '01:45PM',
          '02:00PM',
          '02:15PM',
          '02:30PM',
          '02:45PM',
          '03:00PM',
          '03:15PM',
          '03:30PM',
          '03:45PM',
          '04:00PM',
          '04:15PM',
          '04:30PM',
          '04:45PM',
          '05:00PM',
          '05:15PM',
          '05:30PM',
          '05:45PM',
          '06:00PM',
          '06:15PM',
          '06:30PM',
          '06:45PM',
          '07:00PM',
          '07:15PM',
          '07:30PM',
          '07:45PM',
          '08:00PM',
          '08:15PM',
          '08:30PM',
          '08:45PM',
          '09:00PM',
          '09:15PM',
          '09:30PM',
          '09:45PM',
          '10:00PM',
          '10:15PM',
          '10:30PM',
          '10:45PM',
          '11:00PM',
          '11:15PM',
          '11:30PM',
          '11:45PM',
        ]
        const ordered_array = mapOrder(filterDay.time, times)

        const currentTime = new Date()
        const currentHour = currentTime.getHours()
        const currentMinute = currentTime.getMinutes()
        const currentTimeInMinutes = currentHour * 60 + currentMinute

        // Obtener la hora de la fecha seleccionada
        const selectedHour = singleDate.getHours()
        const selectedMinute = singleDate.getMinutes()
        const selectedTimeInMinutes = selectedHour * 60 + selectedMinute

        let filteredArray

        // Comparar la fecha seleccionada con la fecha actual
        if (singleDate >= currentTime) {
          // Si la fecha seleccionada es mayor o igual a la fecha actual, usar todos los horarios
          filteredArray = ordered_array
        } else if (selectedTimeInMinutes > currentTimeInMinutes) {
          // Si la hora seleccionada es mayor que la hora actual, usar todos los horarios
          filteredArray = ordered_array
        } else {
          // Si la hora seleccionada es igual o menor que la hora actual, filtrar por la hora actual
          filteredArray = ordered_array.filter((time) => {
            const timeInMinutes = parseTime(time)
            return timeInMinutes >= currentTimeInMinutes
          })
        }
        if (
          singleExperience.type === 'PXQ' ||
          singleExperience.type === 'SINGLE' ||
          singleExperience.type === 'PXH'
          // !singleExperience?.specificDates?.length > 0
        ) {
          if (singleExperience?.specificDates?.length > 0) {
            const datesWithTimes = []
            singleExperience?.specificDates?.forEach((item) => {
              const { day, month, year } = item.startDate
              const startDateFormatted = new Date(year, month - 1, day)
              const dateKey = startDateFormatted.toISOString().split('T')[0]
              const itemHour = formatTime(item.hour)
              if (!datesWithTimes[dateKey]) {
                datesWithTimes[dateKey] = {
                  date: startDateFormatted,
                  hours: [{ hour: itemHour, capacity: item.capacity || 0 }],
                }
              } else {
                datesWithTimes[dateKey].hours.push({
                  hour: itemHour,
                  capacity: item.capacity || 0,
                })
              }

              const duplicatedDatesWithTimes = Object.values(
                datesWithTimes,
              ).filter((dateObj) => dateObj.hours.length > 1)
            })
            const formattedDates = singleExperience?.specificDates?.map(
              (item) => {
                const { day, month, year } = item.startDate
                return new Date(year, month - 1, day)
                  .toISOString()
                  .split('T')[0]
              },
            )
            if (formattedDates && formattedDates.includes(formatDate)) {
              for (const key in datesWithTimes) {
                if (key === formatDate) {
                  const matchingReservations = reservations.filter(
                    (reservation) => {
                      return datesWithTimes[key].hours.some(
                        (h) =>
                          reservation.day === formatDate &&
                          h.hour === reservation.hour,
                      )
                    },
                  )
                  const availabilityByHour = datesWithTimes[key].hours.map(
                    (h) => {
                      const reservationsForHour = matchingReservations.filter(
                        (reservation) => reservation.hour === h.hour,
                      )
                      const totalReservationsForHour =
                        reservationsForHour.reduce(
                          (total, reservation) => total + reservation.persons,
                          0,
                        )

                      const remainingAvailabilityForHour =
                        h.capacity - totalReservationsForHour

                      return {
                        hour: h,
                        remainingAvailability: remainingAvailabilityForHour,
                      }
                    },
                  )
                  const hoursAvailables = availabilityByHour
                    .filter((av) => av.remainingAvailability >= guestAmount)
                    .map((dav) => {
                      return dav.hour.hour
                    })

                  setSpecificTimes(hoursAvailables)
                }
              }
            }
          } else {
            for (const dateKey in daysWithHours) {
              if (dateKey === formatDate) {
                if (daysWithHours.hasOwnProperty(dateKey)) {
                  const hours = daysWithHours[dateKey]
                  const matchingReservations = reservations.filter(
                    (reservation) => {
                      return hours.some(
                        (h) =>
                          reservation.day === formatDate &&
                          h === reservation.hour,
                      )
                    },
                  )

                  const availabilityByHour = hours.map((h) => {
                    const reservationsForHour = matchingReservations.filter(
                      (reservation) => reservation.hour === h,
                    )
                    const passengersForHour = reservationsForHour.reduce(
                      (total, reservation) => total + reservation.persons,
                      0,
                    )
                    const remainingAvailabilityForHour =
                      selectedDay.disponibility - passengersForHour
                    return {
                      hour: h,
                      remainingAvailability: remainingAvailabilityForHour,
                    }
                  })
                  const filteredHours = availabilityByHour
                    .filter(
                      ({ remainingAvailability }) =>
                        remainingAvailability >= guestAmount,
                    )
                    .map(({ hour }) => hour)
                  setTimeSelect(filteredHours)
                  setIsDisableTime(false)
                } else {
                  setTimeSelect(filteredArray)
                }
              }
            }
          }
        } else if (singleExperience.type === 'GROUP') {
          if (singleExperience?.specificDates?.length > 0) {
            const datesWithTimes = []
            singleExperience?.specificDates?.forEach((item) => {
              const { day, month, year } = item.startDate
              const startDateFormatted = new Date(year, month - 1, day)
              const dateKey = startDateFormatted.toISOString().split('T')[0]

              const itemHour = formatTime(item.hour)
              if (!datesWithTimes[dateKey]) {
                datesWithTimes[dateKey] = {
                  date: startDateFormatted,
                  hours: [{ hour: itemHour, capacity: item.capacity || 0 }],
                }
              } else {
                datesWithTimes[dateKey].hours.push({
                  hour: itemHour,
                  capacity: item.capacity || 0,
                })
              }

              const duplicatedDatesWithTimes = Object.values(
                datesWithTimes,
              ).filter((dateObj) => dateObj.hours.length > 1)
            })
            const formattedDates = singleExperience?.specificDates?.map(
              (item) => {
                const { day, month, year } = item.startDate
                return new Date(year, month - 1, day)
                  .toISOString()
                  .split('T')[0]
              },
            )
            if (formattedDates && formattedDates.includes(formatDate)) {
              for (const key in datesWithTimes) {
                if (key === formatDate) {
                  const matchingReservations = reservations.filter(
                    (reservation) => {
                      return datesWithTimes[key].hours.some(
                        (h) =>
                          reservation.day === formatDate &&
                          h.hour === reservation.hour,
                      )
                    },
                  )
                  const availabilityByHour = datesWithTimes[key].hours.map(
                    (h) => {
                      const reservationsForHour = matchingReservations.filter(
                        (reservation) => reservation.hour === h.hour,
                      )
                      // const totalReservationsForHour = reservationsForHour.reduce(
                      //   (total, reservation) => total + reservation.persons,
                      //   0,
                      // )

                      const remainingAvailabilityForHour =
                        h.capacity - reservationsForHour.length

                      return {
                        hour: h,
                        remainingAvailability: remainingAvailabilityForHour,
                      }
                    },
                  )
                  const hoursAvailables = availabilityByHour
                    .filter((av) => av.remainingAvailability > 0)
                    .map((dav) => {
                      return dav.hour.hour
                    })

                  setSpecificTimes(hoursAvailables)
                }
              }
            }
          } else {
            for (const dateKey in daysWithHours) {
              if (dateKey === formatDate) {
                if (daysWithHours.hasOwnProperty(dateKey)) {
                  const hours = daysWithHours[dateKey]
                  const matchingReservations = reservations.filter(
                    (reservation) => {
                      return hours.some(
                        (h) =>
                          reservation.day === formatDate &&
                          h === reservation.hour,
                      )
                    },
                  )

                  const availabilityByHour = hours.map((h) => {
                    const reservationsForHour = matchingReservations.filter(
                      (reservation) => reservation.hour === h,
                    )

                    // const totalReservationsForHour = reservationsForHour.reduce(
                    //   (total, reservation) => total + reservation.persons,
                    //   0,
                    // )

                    const remainingAvailabilityForHour =
                      selectedDay.disponibility - reservationsForHour.length

                    return {
                      hour: h,
                      remainingAvailability: remainingAvailabilityForHour,
                    }
                  })
                  const filteredHours = availabilityByHour
                    .filter(
                      ({ remainingAvailability }) => remainingAvailability > 0,
                    )
                    .map(({ hour }) => hour)

                  setTimeSelect(filteredHours)
                  setIsDisableTime(false)
                } else {
                  setTimeSelect(filteredArray)
                }
              }
            }
          }
        }
      }
    }
  }, [singleDate, schedule])
  useEffect(() => {
    const isValidDate =
      day &&
      Object.prototype.toString.call(day) === '[object Date]' &&
      !isNaN(day)
    if (singleExperience?.specificDates?.length > 0) {
      return null
    } else if (isValidDate && (!timeSelect || timeSelect.length === 0)) {
      setOpenTimeSnack(true)
      setIsTimeAvailable(true)
    }
  }, [day, timeSelect])

  useEffect(() => {
    // specificDatesTimeSelect(selectDate)
    setisPreviousDaysOk(false)
    var timeleft = 10
    var downloadTimer = setInterval(function () {
      if (timeleft <= 0) {
        clearInterval(downloadTimer)
        setTimedBlocksAlert(false)
      }
      timeleft -= 1
    }, 1000)

    validEndPeriodDate()
    // setTimeSelectDisponibility()

    if (
      !selectedAddons.length &&
      singleExperience.addons &&
      singleExperience.addons.length
    ) {
      const selected = singleExperience.addons.map((item) => ({
        ...item,
        selected: false,
      }))
      setSelectedAddons(selected)
    }
  }, [selectedDate])

  useEffect(() => {
    resetTotalPersons()
  }, [selectedAddons])

  useEffect(() => {
    getServicesBlockeds()
  }, [])

  const resetSelectedAddons = () => {
    const selected = singleExperience.addons.map((item) => ({
      ...item,
      selected: false,
    }))
    setSelectedAddons([])
    setSelectedAddons(selected)
  }
  const handleMinDate = () => {
    const { dateInit } = singleExperience
    if (singleExperience && singleExperience?.specificDates?.length > 0) {
      const formattedDates = []
      singleExperience?.specificDates?.forEach((item) => {
        const { day, month, year } = item.startDate
        const startDateFormatted = new Date(year, month - 1, day)
        formattedDates.push(startDateFormatted)
      })
      const minDate = formattedDates.reduce(
        (min, date) => (date < min ? date : min),
        formattedDates[0],
      )
      const date = new Date(minDate)
      return date
    }
    if (dateInit) {
      const currentDate = new Date()
      const current = new Date(
        currentDate.setDate(
          currentDate.getDate() + singleExperience.previousDays - 1,
        ),
      )
      const init = new Date(dateInit)

      if (current > init) {
        return current
      } else {
        return init
      }
    } else {
      return new Date()
    }
  }
  const specificDatesTimeSelect = (date) => {
    const datesWithTimes = {}
    const actualDate = new Date(singleDate)
    singleExperience?.specificDates?.forEach((item) => {
      const { day, month, year } = item.startDate
      const startDateFormatted = new Date(year, month - 1, day)
      const dateKey = startDateFormatted.toISOString().split('T')[0]

      if (!datesWithTimes[dateKey]) {
        datesWithTimes[dateKey] = {
          date: startDateFormatted,
          hours: [item.hour],
        }
      } else {
        datesWithTimes[dateKey].hours.push(item.hour)
      }

      const duplicatedDatesWithTimes = Object.values(datesWithTimes).filter(
        (dateObj) => dateObj.hours.length > 1,
      )

      if (
        duplicatedDatesWithTimes.length > 0 &&
        date.toDateString() === duplicatedDatesWithTimes[0].date.toDateString()
      ) {
        setSpecificTimes(duplicatedDatesWithTimes[0].hours)
      } else if (startDateFormatted.toDateString() === date.toDateString()) {
        const selectedHour = formatTime(item.hour)
        setSpecificTimes(selectedHour)
      }
    })

    // Filtrar las fechas que tienen más de un horario

    // Hacer algo con las fechas duplicadas y sus horarios

    // Resto de tu lógica...
  }

  // const selectMaxPassengers = (valueTime) => {
  //   let selectedDate = new Date(singleDate)

  //   let year = selectedDate.getFullYear()
  //   let month = (selectedDate.getMonth() + 1).toString().padStart(2, '0')
  //   let day = selectedDate.getDate().toString().padStart(2, '0')
  //   let numberOfDay = selectedDate.getDay()
  //   const formatDate = year + '-' + month + '-' + day
  //   const selectedDay = scheduleDays[0].find((day) => day.day === numberOfDay)

  //   if (selectedDay && selectedDay.disponibility >= guestAmount) {
  //     const matchingReservations = reservations.filter((reservation) => {
  //       return reservation.day === formatDate && reservation.hour === valueTime
  //     })
  //     if (
  //       singleExperience.type === 'SINGLE' ||
  //       singleExperience.type === 'PXQ'
  //     ) {
  //       if (singleExperience?.specificDates?.length > 0) {
  //         const specificCapacity = []
  //         singleExperience.specificDates.forEach((d) => {
  //           const date = new Date(
  //             d.startDate.year,
  //             d.startDate.month - 1,
  //             d.startDate.day,
  //           )
  //           const dateTimestamp = date.getTime()
  //           const selectedDateTimestamp = selectedDate.getTime()

  //           if (dateTimestamp === selectedDateTimestamp) {
  //             specificCapacity.push(d.capacity)
  //           }
  //         })

  //         const remainingAvailability =
  //           specificCapacity[0] -
  //           matchingReservations.reduce((totalPersons, reservation) => {
  //             return totalPersons + reservation.persons
  //           }, 0)
  //         setIiPassengersCapacity(true)
  //         setOpenSnackPassengers(true)
  //         return setMaxPassengers(remainingAvailability)
  //       }
  //       let totalPersons = 0
  //       for (let reserva of matchingReservations) {
  //         if (reserva.persons) {
  //           totalPersons += reserva.persons
  //         }
  //       }

  //       const maxPassengers = selectedDay.disponibility - totalPersons
  //       setMaxPassengers(maxPassengers)
  //       if (maxPassengers <= 0) {
  //         setIsAvailableCapacity(true)
  //         setOpenSnackBarCapacity(true)
  //       } else {
  //         setIsAvailableCapacity(false)
  //         setOpenSnackBarCapacity(false)
  //       }
  //     } else if (singleExperience.type === 'GROUP') {
  //       setMaxPassengers(singleExperience.typePersons)

  //     }
  //   }
  // }

  // const isDayAvailable = () => {
  //   let selectedDate = new Date(singleDate)

  //   let year = selectedDate.getFullYear()
  //   let month = (selectedDate.getMonth() + 1).toString().padStart(2, '0')
  //   let day = selectedDate.getDate().toString().padStart(2, '0')
  //   let numberOfDay = selectedDate.getDay()
  //   const formatDate = year + '-' + month + '-' + day
  //   const selectedDay = scheduleDays[0].find((day) => day.day === numberOfDay)

  //   if (selectedDay) {
  //     const matchingReservations = reservations.filter((reservation) => {
  //       return reservation.day === formatDate && reservation.hour === time
  //     })
  //     if (singleExperience.type === 'SINGLE') {
  //       if (singleExperience?.specificDates?.length > 0) {
  //         if (matchingReservations.length > 0) {
  //           const specificCapacity = []
  //           singleExperience.specificDates.forEach((d) => {
  //             const date = new Date(
  //               d.startDate.year,
  //               d.startDate.month - 1,
  //               d.startDate.day,
  //             )
  //             const dateTimestamp = date.getTime()
  //             const selectedDateTimestamp = selectedDate.getTime()

  //             if (dateTimestamp === selectedDateTimestamp) {
  //               specificCapacity.push(d.capacity)
  //             }
  //           })

  //           const remainingAvailability =
  //             selectedDay.disponibility -
  //             matchingReservations.reduce((totalPersons, reservation) => {
  //               return totalPersons + reservation.persons
  //             }, 0)

  //           if (remainingAvailability >= guestAmount) {
  //             setIsAvailableCapacity(false)
  //             setOpenSnackBarCapacity(false)
  //             return true
  //           } else {
  //             setIsAvailableCapacity(true)
  //             setOpenSnackBarCapacity(true)
  //             return false
  //           }
  //         } else {
  //           setIsAvailableCapacity(false)
  //           setOpenSnackBarCapacity(false)
  //           return true
  //         }
  //       }
  //       if (matchingReservations.length > 0) {
  //         const remainingAvailability =
  //           selectedDay.disponibility -
  //           matchingReservations.reduce((totalPersons, reservation) => {
  //             return totalPersons + reservation.persons
  //           }, 0)
  //         if (remainingAvailability >= guestAmount) {
  //           setIsAvailableCapacity(false)
  //           setOpenSnackBarCapacity(false)
  //           return true
  //         } else {
  //           setIsAvailableCapacity(true)
  //           setOpenSnackBarCapacity(true)
  //           return false
  //         }
  //       } else {
  //         setIsAvailableCapacity(false)
  //         setOpenSnackBarCapacity(false)
  //         return true
  //       }
  //     } else if (singleExperience.type === 'PXQ') {
  //       if (singleExperience?.specificDates?.length > 0) {
  //         if (matchingReservations.length > 0) {
  //           const specificCapacity = []
  //           singleExperience.specificDates.forEach((d) => {
  //             const date = new Date(
  //               d.startDate.year,
  //               d.startDate.month - 1,
  //               d.startDate.day,
  //             )
  //             const dateTimestamp = date.getTime()
  //             const selectedDateTimestamp = selectedDate.getTime()

  //             if (dateTimestamp === selectedDateTimestamp) {
  //               specificCapacity.push(d.capacity)
  //             }
  //           })

  //           const remainingAvailability =
  //             selectedDay.disponibility -
  //             matchingReservations.reduce((totalPersons, reservation) => {
  //               return totalPersons + reservation.persons
  //             }, 0)

  //           if (remainingAvailability >= guestAmount) {
  //             setIsAvailableCapacity(false)
  //             setOpenSnackBarCapacity(false)
  //             return true
  //           } else {
  //             setIsAvailableCapacity(true)
  //             setOpenSnackBarCapacity(true)
  //             return false
  //           }
  //         } else {
  //           setIsAvailableCapacity(false)
  //           setOpenSnackBarCapacity(false)
  //           return true
  //         }
  //       }
  //       if (matchingReservations.length > 0) {
  //         const remainingAvailability =
  //           selectedDay.disponibility -
  //           matchingReservations.reduce((totalPersons, reservation) => {
  //             return totalPersons + reservation.persons
  //           }, 0)

  //         if (remainingAvailability >= guestAmount) {
  //           setIsAvailableCapacity(false)
  //           setOpenSnackBarCapacity(false)
  //           return true
  //         } else {
  //           setIsAvailableCapacity(true)
  //           setOpenSnackBarCapacity(true)
  //           return false
  //         }
  //       } else {
  //         setIsAvailableCapacity(false)
  //         setOpenSnackBarCapacity(false)
  //         return true
  //       }
  //     } else if (singleExperience.type === 'GROUP') {
  //       if (singleExperience?.specificDates?.length > 0) {
  //         if (matchingReservations.length > 0) {
  //           const specificCapacity = []
  //           singleExperience.specificDates.forEach((d) => {
  //             const date = new Date(
  //               d.startDate.year,
  //               d.startDate.month - 1,
  //               d.startDate.day,
  //             )
  //             const dateTimestamp = date.getTime()
  //             const selectedDateTimestamp = selectedDate.getTime()

  //             if (dateTimestamp === selectedDateTimestamp) {
  //               specificCapacity.push(d.capacity)
  //             }
  //           })
  //           if (matchingReservations.length >= specificCapacity[0]) {
  //             setIsAvailableCapacity(true)
  //             setOpenSnackBarCapacity(true)
  //             return false
  //           } else {
  //             setIsAvailableCapacity(false)
  //             setOpenSnackBarCapacity(false)
  //             return true
  //           }
  //         } else {
  //           setIsAvailableCapacity(false)
  //           setOpenSnackBarCapacity(false)
  //           return true
  //         }
  //       }
  //       if (matchingReservations.length > 0) {
  //         // let totalPersons = 0
  //         // for (let reserva of matchingReservations) {
  //         //   if (reserva.persons) {
  //         //     totalPersons += reserva.persons
  //         //   }
  //         // }
  //         // const availablePassengers =
  //         //   selectedDay.disponibility * singleExperience.typePersons
  //         // const finalDisponibility = availablePassengers - totalPersons

  //         if (matchingReservations.length >= selectedDay.disponibility) {
  //           setIsAvailableCapacity(true)
  //           setOpenSnackBarCapacity(true)
  //           return false
  //         } else {
  //           setIsAvailableCapacity(false)
  //           setOpenSnackBarCapacity(false)
  //           return true
  //         }
  //       } else {
  //         setIsAvailableCapacity(false)
  //         setOpenSnackBarCapacity(false)
  //         return true
  //       }
  //     }
  //   }

  //   setIsAvailableCapacity(true)
  //   setOpenSnackBarCapacity(true)
  //   return false
  // }

  const validateSingleDate = () => {
    if (singleDate === null) {
      setIsErrorSingleDate(true)
      return false
    } else {
      setIsErrorSingleDate(false)
      return true
    }
  }

  const validTime = () => {
    if (timeConverted) {
      setIsErrorTime(false)
      return true
    } else {
      setIsErrorTime(true)
      return false
    }
  }

  const validGuestAmount = () => {
    if (guestAmount === 0) {
      setIsErrorGuestAmount(true)
      return false
    }

    setIsErrorGuestAmount(false)
    return true
  }

  const validateReservationPrice = () => {
    if (reservationPrice < 1000) {
      return false
    }
    return true
  }

  const validateForm = async () => {
    const boolPreviousDays = validPreviousDays()
    const boolSingleDate = validateSingleDate()
    const boolTime = validTime()
    const boolGuestAmount = validGuestAmount()
    const boolReservationPrice = validateReservationPrice()
    // const availableDay = isDayAvailable()

    if (!boolReservationPrice) {
      setSnackOpen({
        ...snackOpen,
        isOpen: true,
        message: 'El total no puede ser menos a $1000',
      })
      return
    }

    // if (!boolPreviousDays && !giftCard) {
    //   setisPreviousDaysOk(true)
    //   setSnackOpen({
    //     ...snackOpen,
    //     isOpen: true,
    //     message: `Esta experiencia necesita reservarse ${singleExperience.previousDays} días previos al día en que se realiza.`,
    //   })
    //   return
    // }

    if (boolSingleDate && boolTime && boolGuestAmount) {
      if (singleExperience.partialPercentage > 0) {
        setPartialPrice(
          ((!!reservationPrice
            ? reservationPrice + addonsPrice + addonsPersonsPrice
            : 0) *
            singleExperience.partialPercentage) /
            100,
        )
        calculateExitDate()
        handleNext()
      } else {
        calculateExitDate()
        handleNext()
      }
    }
  }

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      validateForm()
    }
  }

  const guestIsDisable = () => {
    if (isExperiencesEnded) {
      return true
    }

    // if (!singleDate) {
    //   return true
    // }

    return false
  }

  const handleAddons = (event, addon, index) => {
    if (event) {
      const copyAddons = [...selectedAddons]
      copyAddons[index] = { ...copyAddons[index], selected: true }
      setSelectedAddons(copyAddons)
      const totalGuest = guestAmount + childAmount
      //Se agrega el precio del addon
      const addPrice = addonsPrice + totalGuest * addon.price
      setAddonsPrice(addPrice)
      setTotalPrice(addPrice + reservationPrice)
      setPartialPrice(
        (addPrice + reservationPrice) *
          (singleExperience.partialPercentage / 100),
      )
    } else {
      const copyAddons = [...selectedAddons]
      copyAddons[index] = { ...copyAddons[index], selected: false }
      setSelectedAddons(copyAddons)
      const totalGuest = guestAmount + childAmount
      //se resta el precio del addon
      const minusPrice = addonsPrice - totalGuest * addon.price
      setAddonsPrice(minusPrice)
      setTotalPrice(reservationPrice + minusPrice)
      setPartialPrice(
        (reservationPrice + minusPrice) *
          (singleExperience.partialPercentage / 100),
      )
    }
  }

  const handleAddonsSpecial = (event, addon, index) => {
    const copyAddons = [...selectedAddons]
    copyAddons[index] = { ...copyAddons[index], selected: event }
    setSelectedAddons(copyAddons)
    totalizerAddons()
  }

  const handleChangeQty = (quantity, addon, index) => {
    selectedAddons[index].quantity = quantity
    setSelectedAddons(selectedAddons)
    totalizerAddons()
  }

  const totalizerAddons = () => {
    let sum = 0
    const addons = selectedAddons.filter(
      (fil) => fil.isSpecial && fil.selected && fil.quantity > 0,
    )
    if (addons.length > 0) {
      addons.map((addon, index) => {
        sum = sum + addon.price * addon.quantity
      })
      setAddonsPersonsPrice(sum)
      // setTotalAddonsPersons(sum)
    } else {
      setAddonsPersonsPrice(0)
    }
  }

  const resetTotalPersons = () => {
    const total = 0
    setTimeout(() => {
      setAddonsPersonsPrice(total)
      totalizerAddons()
    }, 500)
  }

  const validateServiceHour = async (hour) => {
    const selectedDay = moment(singleDate).day()

    const data = {
      agencyId: agency.key,
      experienceId: singleExperience.key,
      day: formatDateToDB(singleDate),
      hour: hour,
    }

    const serviceAvailable = await getServiceByDayAndHour(data)

    if (serviceAvailable.isBlocked) {
      setTime('')
      setIsServiceBlocked(true)
      return
    }

    //El servicio existe, se valida si tiene disponibilidad
    if (serviceAvailable.key) {
      if (serviceAvailable.isBlocked) {
        setSnackOpen({
          ...snackOpen,
          isOpen: true,
          message:
            'La experiencia no se encuentra disponible en la fecha selecciona. Por favor, seleccione otra fecha.',
        })
        setTime('')

        setIsServiceBlocked(true)
        return false
      } else {
        setIsServiceBlocked(false)
      }
    }
  }

  function setTimeSelectDisponibility() {
    const date = new Date()
    const timeSelect2 = []
    if (
      selectedDate?.toLocaleDateString('en-US') ===
      date.toLocaleDateString('en-US')
    ) {
      timeSelect.map((t) => {
        let date2 = new Date()
        let t2 = t.split(':')
        const hour = t2[0]
        let minutes = ''
        if (t2[1].includes('A')) {
          minutes = t2[1].split('A')[0]
          date2.setHours(+hour - 12, +minutes)
        } else {
          minutes = t2[1].split('P')[0]
          date2.setHours(+hour - 12, +minutes)
        }
        if (date2 > date) {
          timeSelect2.push(t)
        }
      })
      setTimeSelect(timeSelect2)
    }
  }

  const handleMaxDate = () => {
    const { dateEnd } = singleExperience
    if (singleExperience && singleExperience?.specificDates?.length > 0) {
      const formattedDates = []
      singleExperience?.specificDates?.forEach((item) => {
        const { day, month, year } = item.startDate
        const startDateFormatted = new Date(year, month - 1, day)
        formattedDates.push(startDateFormatted)
      })
      const maxDate = formattedDates.reduce(
        (max, date) => (date > max ? date : max),
        formattedDates[0],
      )
      const date = new Date(maxDate)
      date.setDate(date.getDate() + 1)
      return date
    }
    if (dateEnd) {
      return new Date(dateEnd)
    }
  }

  const validEndPeriodDate = () => {
    const { dateEnd } = singleExperience

    if (dateEnd) {
      const finalDate = new Date(dateEnd)
      const currentDate = new Date()

      if (currentDate > finalDate) {
        setIsExperienceEnded(true)
        setOpenSnackBar(true)
      } else {
        setIsExperienceEnded(false)
      }
    } else {
      setIsExperienceEnded(false)
    }
  }

  const handlePanelChange = (value, mode) => {
    if (mode === 'date') {
      const currentMonth = dayjs(value)
      const daysInMonth = currentMonth.daysInMonth()
      const startDate = currentMonth.startOf('month')
      const datesArray = Array.from({ length: daysInMonth }, (_, index) =>
        startDate.add(index, 'days'),
      )

      const formattedDates = datesArray.map((date) => date.format('YYYY-MM-DD'))
      setSelectedDate()

      setSelectedDates(formattedDates)
    }
  }

  const handleOpenChange = (open) => {
    if (open && !initialized) {
      // Ejecutar la lógica cuando el DatePicker se abre por primera vez
      const currentMonth = dayjs()
      const daysInMonth = currentMonth.daysInMonth()
      const startDate = currentMonth.startOf('month')
      const datesArray = Array.from({ length: daysInMonth }, (_, index) =>
        startDate.add(index, 'days'),
      )

      const formattedDates = datesArray.map((date) => date.format('YYYY-MM-DD'))
      setSelectedDates(formattedDates)

      setInitialized(true)
    }
  }
  const addHoursToDates = () => {
    if (selectedDates.length > 0) {
      const dayNumbers = selectedDates.map((date) => dayjs(date).day())
      const schedulePeriodicity = schedule.days
      const daysWithHours = {}
      dayNumbers.forEach((dayNumber, index) => {
        const arrayScheduleHours = schedulePeriodicity[dayNumber].time
        daysWithHours[selectedDates[index]] = arrayScheduleHours
      })
      setDaysWithHours(daysWithHours)
    }
  }

  function formatTime(time) {
    const [hours, minutes] = time.split(':')
    let formattedHours = parseInt(hours, 10)
    let period = 'AM'

    if (formattedHours >= 12) {
      period = 'PM'
      if (formattedHours > 12) {
        formattedHours -= 12
      }
    }

    return `${formattedHours.toString().padStart(2, '0')}:${minutes}${period}`
  }

  const filterDates = (date) => {
    if (singleExperience?.specificDates?.length > 0) {
      return filterDatesSpecifics(date)
    } else {
      return filterDatesRecurrent(date)
    }
  }

  const filterDatesSpecifics = (date) => {
    const dateToDate = date.toDate()
    const selectedDate = Date.UTC(
      dateToDate.getFullYear(),
      dateToDate.getMonth(),
      dateToDate.getDate(),
    )
    const actualDate = new Date().toISOString().split('T')[0]
    const selectedDateUtc = new Date(selectedDate)
    const dateString = selectedDateUtc.toISOString().split('T')[0]
    const datesWithTimes = []
    singleExperience?.specificDates?.forEach((item) => {
      const { day, month, year } = item.startDate
      const startDateFormatted = new Date(year, month - 1, day)
      const dateKey = startDateFormatted.toISOString().split('T')[0]

      const itemHour = formatTime(item.hour)
      if (!datesWithTimes[dateKey]) {
        datesWithTimes[dateKey] = {
          date: startDateFormatted,
          hours: [{ hour: itemHour, capacity: item.capacity || 0 }],
        }
      } else {
        datesWithTimes[dateKey].hours.push({
          hour: itemHour,
          capacity: item.capacity || 0,
        })
      }

      const duplicatedDatesWithTimes = Object.values(datesWithTimes).filter(
        (dateObj) => dateObj.hours.length > 1,
      )
    })
    const formattedDates = singleExperience?.specificDates?.map((item) => {
      const { day, month, year } = item.startDate
      return new Date(year, month - 1, day).toISOString().split('T')[0]
    })
    if (formattedDates && formattedDates.includes(dateString)) {
      if (dateString < actualDate) {
        return false
      }
      if (singleExperience.type === 'GROUP') {
        for (const key in datesWithTimes) {
          if (key === dateString) {
            if (datesWithTimes[key].hours.length > 0) {
              if (datesWithTimes[key].hours.length < 2) {
                const matchingReservations = reservations.filter(
                  (reservation) => {
                    return (
                      reservation.day === dateString &&
                      reservation.hour === datesWithTimes[key].hours[0].hour
                    )
                  },
                )

                if (
                  matchingReservations.length >=
                  datesWithTimes[key].hours[0].capacity
                ) {
                  return true
                } else {
                  return false
                }
              } else {
                const matchingReservations = reservations.filter(
                  (reservation) => {
                    return datesWithTimes[key].hours.some(
                      (h) =>
                        reservation.day === dateString &&
                        h.hour === reservation.hour,
                    )
                  },
                )
                const hoursOfDay = [
                  ...new Set(
                    matchingReservations.map(
                      (matchingReservation) => matchingReservation.hour,
                    ),
                  ),
                ]
                const uniqueHours = new Set(hoursOfDay)
                if (matchingReservations.length > 0) {
                  if (uniqueHours.size === datesWithTimes[key].hours.length) {
                    const totalCapacity = datesWithTimes[key].hours.reduce(
                      (total, hourObj) => total + hourObj.capacity,
                      0,
                    )
                    if (totalCapacity > matchingReservations.length) {
                      return false
                    } else {
                      const availabilityByHour = datesWithTimes[key].hours.map(
                        (h) => {
                          const reservationsForHour =
                            matchingReservations.filter(
                              (reservation) => reservation.hour === h.hour,
                            )

                          const remainingAvailabilityForHour =
                            datesWithTimes[key].hours.capacity -
                            reservationsForHour.length
                          return {
                            hour: h,
                            remainingAvailability: remainingAvailabilityForHour,
                          }
                        },
                      )

                      if (availabilityByHour.length > 0) {
                        const checkDay = availabilityByHour.filter(
                          (h) => h.remainingAvailability > 0,
                        )
                        if (checkDay.length > 0) {
                          return false
                        } else {
                          return true
                        }
                      }
                    }
                  }
                } else {
                  return false
                }
              }
            } else {
              return true
            }
          }
        }
      } else if (
        singleExperience.type === 'PXQ' ||
        singleExperience.type === 'SINGLE' ||
        singleExperience.type === 'PXH'
      ) {
        for (const key in datesWithTimes) {
          if (key === dateString) {
            if (datesWithTimes[key].hours.length > 0) {
              if (datesWithTimes[key].hours.length < 2) {
                const matchingReservations = reservations.filter(
                  (reservation) => {
                    return (
                      reservation.day === dateString &&
                      reservation.hour === datesWithTimes[key].hours[0].hour
                    )
                  },
                )
                const remainingAvailability =
                  datesWithTimes[key].hours[0].capacity -
                  matchingReservations.reduce((totalPersons, reservation) => {
                    return totalPersons + reservation.persons
                  }, 0)

                if (
                  remainingAvailability < guestAmount ||
                  guestAmount > datesWithTimes[key].hours[0].capacity ||
                  remainingAvailability < 0
                ) {
                  return true
                } else if (actualDate > dateString) {
                  return true
                } else if (
                  guestAmount <= datesWithTimes[key].hours[0].capacity
                ) {
                  return false
                }
              } else {
                const matchingReservations = reservations.filter(
                  (reservation) => {
                    return datesWithTimes[key].hours.some(
                      (h) =>
                        reservation.day === dateString &&
                        h.hour === reservation.hour,
                    )
                  },
                )
                const hoursOfDay = [
                  ...new Set(
                    matchingReservations.map(
                      (matchingReservation) => matchingReservation.hour,
                    ),
                  ),
                ]
                const uniqueHours = new Set(hoursOfDay)
                if (matchingReservations.length > 0) {
                  if (uniqueHours.size === datesWithTimes[key].hours.length) {
                    const totalCapacity =
                      datesWithTimes[key].hours.reduce(
                        (total, hourObj) => total + hourObj.capacity,
                        0,
                      ) -
                      matchingReservations.reduce(
                        (totalPersons, reservation) => {
                          return totalPersons + reservation.persons
                        },
                        0,
                      )

                    const availabilityByHour = datesWithTimes[key].hours.map(
                      (h) => {
                        const reservationsForHour = matchingReservations.filter(
                          (reservation) => reservation.hour === h.hour,
                        )
                        const passengersForHour = reservationsForHour.reduce(
                          (total, reservation) => total + reservation.persons,
                          0,
                        )
                        const remainingAvailabilityForHour =
                          h.capacity - passengersForHour
                        return {
                          hour: h,
                          remainingAvailability: remainingAvailabilityForHour,
                        }
                      },
                    )

                    if (availabilityByHour.length > 0) {
                      const checkDay = availabilityByHour.filter(
                        (h) => h.remainingAvailability >= guestAmount,
                      )
                      if (checkDay.length > 0) {
                        return false
                      } else {
                        return true
                      }
                    } else {
                      return true
                    }
                  }
                } else {
                  return false
                }
              }
            } else {
              if (datesWithTimes[key].hours[0].capacity >= guestAmount) {
                return false
              } else {
                return true
              }
            }
          }
        }
      }
      return false
    } else {
      // La fecha no está incluida en formattedDates
      return true
    }
  }

  const filterDatesRecurrent = (date) => {
    const days = ['Dom', 'Lun', 'Mar', 'Mie', 'Jue', 'Vie', 'Sab']
    const getDay = date.day()
    const selectedDate = new Date(date)
    let year = selectedDate.getFullYear()
    let month = (selectedDate.getMonth() + 1).toString().padStart(2, '0')
    let day = selectedDate.getDate().toString().padStart(2, '0')
    let numberOfDay = selectedDate.getDay()
    const formatDate = year + '-' + month + '-' + day
    const selectedDay = scheduleDays[0].find((day) => day.day === numberOfDay)

    function sortDays(a, b) {
      return days.indexOf(a.name) - days.indexOf(b.name)
    }
    const hoursSchedulePeriodicity = schedule.days
    hoursSchedulePeriodicity.sort(sortDays)
    const arrayScheduleHours = hoursSchedulePeriodicity[getDay].time
    if (arrayScheduleHours.length === 0) {
      return true
    }

    if (daysWithHours && Object.keys(daysWithHours).length > 0) {
      // Recorrer las claves (fechas) en daysWithHours
      for (const dateKey in daysWithHours) {
        if (daysWithHours.hasOwnProperty(dateKey)) {
          // Verificar si la fecha actual coincide con la fecha en daysWithHours
          if (dateKey === formatDate) {
            const hours = daysWithHours[dateKey]
            const dayOfWeek = selectedDate.getDay()
            const dayName = days[dayOfWeek]
            if (selectedDay && selectedDay.disponibility) {
              const matchingReservations = reservations.filter(
                (reservation) => {
                  return hours.some(
                    (h) =>
                      reservation.day === formatDate && h === reservation.hour,
                  )
                },
              )
              matchingReservations.forEach((matchingReservation) => {
                const reservationHour = matchingReservation.hour
              })
              if (singleExperience.type === 'GROUP') {
                if (hours.length < 2) {
                  if (matchingReservations.length > 0) {
                    if (
                      selectedDay.disponibility > matchingReservations.length
                    ) {
                      return false
                    } else {
                      return true
                    }
                  }
                } else {
                  const hoursOfDay = [
                    ...new Set(
                      matchingReservations.map(
                        (matchingReservation) => matchingReservation.hour,
                      ),
                    ),
                  ]
                  const uniqueHours = new Set(hoursOfDay)
                  if (matchingReservations.length > 0) {
                    if (uniqueHours.size === hours.length) {
                      if (
                        selectedDay.disponibility > matchingReservations.length
                      ) {
                        return false
                      } else {
                        const availabilityByHour = hours.map((h) => {
                          const reservationsForHour =
                            matchingReservations.filter(
                              (reservation) => reservation.hour === h,
                            )

                          const remainingAvailabilityForHour =
                            selectedDay.disponibility -
                            reservationsForHour.length
                          return {
                            hour: h,
                            remainingAvailability: remainingAvailabilityForHour,
                          }
                        })

                        if (availabilityByHour.length > 0) {
                          const checkDay = availabilityByHour.filter(
                            (h) => h.remainingAvailability > 0,
                          )

                          if (checkDay.length > 0) {
                            return false
                          } else {
                            return true
                          }
                        } else {
                          return true
                        }
                      }
                    }
                  } else {
                    if (
                      selectedDay.disponibility > matchingReservations.length
                    ) {
                      return false
                    } else {
                      return true
                    }
                  }
                }
              } else if (
                singleExperience.type === 'PXQ' ||
                singleExperience.type === 'SINGLE' ||
                singleExperience.type === 'PXH'
              ) {
                if (hours.length < 2) {
                  if (matchingReservations.length > 0) {
                    const remainingAvailability =
                      selectedDay.disponibility -
                      matchingReservations.reduce(
                        (totalPersons, reservation) => {
                          return totalPersons + reservation.persons
                        },
                        0,
                      )
                    if (remainingAvailability >= guestAmount) {
                      return false
                    } else {
                      return true
                    }
                  } else {
                    if (selectedDay.disponibility >= guestAmount) {
                      return false
                    } else {
                      return true
                    }
                  }
                } else {
                  const hoursOfDay = [
                    ...new Set(
                      matchingReservations.map(
                        (matchingReservation) => matchingReservation.hour,
                      ),
                    ),
                  ]
                  const uniqueHours = new Set(hoursOfDay)
                  if (matchingReservations.length > 0) {
                    if (uniqueHours.size === hours.length) {
                      const remainingAvailability =
                        selectedDay.disponibility -
                        matchingReservations.reduce(
                          (totalPersons, reservation) => {
                            return totalPersons + reservation.persons
                          },
                          0,
                        )

                      if (remainingAvailability >= guestAmount) {
                        return false
                      } else {
                        const availabilityByHour = hours.map((h) => {
                          const reservationsForHour =
                            matchingReservations.filter(
                              (reservation) => reservation.hour === h,
                            )
                          const passengersForHour = reservationsForHour.reduce(
                            (total, reservation) => total + reservation.persons,
                            0,
                          )
                          const remainingAvailabilityForHour =
                            selectedDay.disponibility - passengersForHour
                          return {
                            hour: h,
                            remainingAvailability: remainingAvailabilityForHour,
                          }
                        })
                        const filteredHours = availabilityByHour
                          .filter(
                            ({ remainingAvailability }) =>
                              remainingAvailability >= guestAmount,
                          )
                          .map(({ hour }) => hour)
                        const remainingAvailability =
                          selectedDay.disponibility -
                          matchingReservations.reduce(
                            (totalPersons, reservation) => {
                              return totalPersons + reservation.persons
                            },
                            0,
                          )
                        if (availabilityByHour.length > 0) {
                          const checkDay = availabilityByHour.filter(
                            (h) => h.remainingAvailability >= guestAmount,
                          )

                          if (checkDay.length > 0) {
                            return false
                          } else {
                            return true
                          }
                        } else {
                          return true
                        }
                      }
                    } else {
                      const remainingAvailability =
                        selectedDay.disponibility -
                        matchingReservations.reduce(
                          (totalPersons, reservation) => {
                            return totalPersons + reservation.persons
                          },
                          0,
                        )

                      if (remainingAvailability >= guestAmount) {
                        return false
                      } else {
                        const availabilityByHour = hours.map((h) => {
                          const reservationsForHour =
                            matchingReservations.filter(
                              (reservation) => reservation.hour === h,
                            )
                          const passengersForHour = reservationsForHour.reduce(
                            (total, reservation) => total + reservation.persons,
                            0,
                          )
                          const remainingAvailabilityForHour =
                            selectedDay.disponibility - passengersForHour
                          return {
                            hour: h,
                            remainingAvailability: remainingAvailabilityForHour,
                          }
                        })
                        const filteredHours = availabilityByHour
                          .filter(
                            ({ remainingAvailability }) =>
                              remainingAvailability >= guestAmount,
                          )
                          .map(({ hour }) => hour)
                        const remainingAvailability =
                          selectedDay.disponibility -
                          matchingReservations.reduce(
                            (totalPersons, reservation) => {
                              return totalPersons + reservation.persons
                            },
                            0,
                          )
                        if (availabilityByHour.length > 0) {
                          const checkDay = availabilityByHour.filter(
                            (h) => h.remainingAvailability >= guestAmount,
                          )

                          if (checkDay.length > 0) {
                            return false
                          } else {
                            return true
                          }
                        } else {
                          return true
                        }
                      }
                    }
                  } else {
                    if (selectedDay.disponibility >= guestAmount) {
                      return false
                    } else {
                      return true
                    }
                  }
                }
              }
            }
          }
        }
      }
    }

    const periodicity = singleExperience.periodicity.indexOf(days[getDay])
    return periodicity === -1
  }

  const handleGuestAmount = async (value, type) => {
    if (type === 'adult') {
      setIsErrorGuestAmount(false)
      const totalGuest = value + childAmount

      if (
        singleExperience.typePersons === 0 ||
        totalGuest <= singleExperience.typePersons
      ) {
        setGuestAmount(parseInt(value, 10))
        // handlePrice(parseInt(value, 10), type)
      } else {
        setIsErrorGuestAmount(true)
      }
    } else {
      setIsErrorChildAmount(false)
      const totalGuest = value + guestAmount

      if (
        singleExperience.typePersons === 0 ||
        totalGuest <= singleExperience.typePersons
      ) {
        setChildAmount(parseInt(value, 10))
        // handlePrice(parseInt(value, 10), type)
      } else {
        setIsErrorChildAmount(true)
      }
    }
  }

  const handlePrice = (amount, type) => {
    if (singleExperience.type === 'GROUP') {
      handleGroupPrice(amount, type)
    } else if (singleExperience.type === 'SINGLE') {
      handleSinglePrice(amount, type)
    } else {
      handlePxqPrice(amount, type)
    }
  } // esto no deberia funcionar para hotel y experiencia

  const handlePxqPrice = (amount, type) => {
    let adultPrice = 0,
      childPrice = 0,
      addonTotalPrice = 0
    if (type === 'adult') {
      const addonPriceArray = selectedAddons
        .filter((item) => item.selected && !item.isSpecial)
        .map((item) => item.price)
      const addonAddArray = addArrayItems(addonPriceArray)
      const totalGuest =
        type === 'adult' ? amount + childAmount : amount + guestAmount
      addonTotalPrice = addonAddArray * totalGuest
      setAddonsPrice(addonTotalPrice)

      if (
        singleExperience?.priceQuantity?.length > 0 &&
        singleExperience.type === 'PXQ' &&
        !resultPxq
      ) {
        const pricesQuantity = singleExperience.priceQuantity
        const index = pricesQuantity.findIndex(
          (x) => x.from <= amount && x.to >= amount,
        )

        adultPrice =
          amount *
          pricesQuantity[index !== -1 ? index : pricesQuantity.length - 1].price
      } else if (
        singleExperience?.pricePerHour?.length > 0 &&
        singleExperience.type === 'PXH'
      ) {
        const isWeekend = singleDate.getDay() === 6 || singleDate.getDay() === 0

        // Obtener la lista de precios por hora de singleExperience
        const pricesQuantity = singleExperience?.pricePerHour || []

        // Buscar el precio correspondiente según la cantidad de horas y si es fin de semana o no
        const priceData = pricesQuantity.find((price) => {
          const from = parseInt(price.from)
          const to = parseInt(price.to)
          return from <= amount && amount <= to
        })

        if (priceData) {
          // Asignar el precio adecuado dependiendo de si es fin de semana o no
          if (onSeasons?.isActive) {
            adultPrice = isWeekend
              ? priceData.weekendPrice + onSeasons.increase
              : priceData.price + onSeasons.increase
          } else {
            adultPrice = isWeekend ? priceData.weekendPrice : priceData.price
          }
        } else {
          // Si no hay datos de precio para la cantidad de horas seleccionada, tomar el último precio de la lista
          const lastIndex = pricesQuantity.length - 1
          adultPrice = isWeekend
            ? pricesQuantity[lastIndex].weekendPrice
            : pricesQuantity[lastIndex].price
        }
      } else {
        adultPrice = amount * singleExperience.valuePerPerson
      }

      childPrice = childAmount * singleExperience.valuePerChild

      setReservationPrice(adultPrice + childPrice)

      setTotalPrice(adultPrice + childPrice + addonTotalPrice)

      if (singleExperience.isPartialCharge) {
        setPartialPrice(
          (adultPrice + childPrice + addonTotalPrice) *
            (singleExperience.partialPercentage / 100),
        )
      }
    } else {
      const addonPriceArray = selectedAddons
        .filter((item) => item.selected && !item.isSpecial)
        .map((item) => item.price)
      const addonAddArray = addArrayItems(addonPriceArray)
      const totalGuest =
        type === 'adult' ? amount + childAmount : amount + guestAmount
      addonTotalPrice = addonAddArray * totalGuest
      setAddonsPrice(addonTotalPrice)

      childPrice = amount * singleExperience.valuePerChild
      adultPrice = guestAmount * singleExperience.valuePerPerson
      setReservationPrice(childPrice + adultPrice)
      setTotalPrice(adultPrice + childPrice + addonTotalPrice)
    }
  }

  const handleGroupPrice = (amount, type) => {
    if (!amount) {
      setReservationPrice(0)
      setTotalPrice(0)
      setAddonsPersonsPrice(0)
      setPartialPrice(0)
    } else {
      let reservationPrice = 0,
        addonTotalPrice = 0
      if (singleExperience.seasons && singleExperience.seasons.length) {
        const season = singleExperience.seasons.filter((season) =>
          checkDateIsBetweenRange(
            formatDateToDB(singleDate),
            season.startDate,
            season.endDate,
          ),
        )

        if (season.length) {
          //Calcular precio de Addons
          const addonPriceArray = selectedAddons
            .filter((item) => item.selected && !item.isSpecial)
            .map((item) => item.price)
          const addonAddArray = addArrayItems(addonPriceArray)
          const totalGuest =
            type === 'adult' ? amount + childAmount : amount + guestAmount
          addonTotalPrice = addonAddArray * totalGuest
          setAddonsPrice(addonTotalPrice)

          //Calcular precio de la reserva mas Addons
          reservationPrice = season[0].adultPrice
          setReservationPrice(reservationPrice)
          setTotalPrice(reservationPrice + addonTotalPrice)
        } else {
          //Calcular precio de Addons
          const addonPriceArray = selectedAddons
            .filter((item) => item.selected && !item.isSpecial)
            .map((item) => item.price)
          const addonAddArray = addArrayItems(addonPriceArray)
          const totalGuest =
            type === 'adult' ? amount + childAmount : amount + guestAmount
          addonTotalPrice = addonAddArray * totalGuest
          setAddonsPrice(addonTotalPrice)

          //Calcular precio de la reserva mas Addons
          reservationPrice = singleExperience.valuePerPerson
          setReservationPrice(reservationPrice)
          setTotalPrice(reservationPrice + addonTotalPrice)
        }
      } else {
        //Calcular precio de Addons
        const addonPriceArray = selectedAddons
          .filter((item) => item.selected && !item.isSpecial)
          .map((item) => item.price)
        const addonAddArray = addArrayItems(addonPriceArray)
        const totalGuest =
          type === 'adult' ? amount + childAmount : amount + guestAmount
        addonTotalPrice = addonAddArray * totalGuest
        setAddonsPrice(addonTotalPrice)

        //Calcular precio de la reserva mas Addons
        reservationPrice = singleExperience.valuePerPerson
        setReservationPrice(reservationPrice)
        setTotalPrice(reservationPrice + addonTotalPrice)
      }

      if (singleExperience.isPartialCharge) {
        const calcPartialPrice =
          (reservationPrice + addonTotalPrice) *
          (singleExperience.partialPercentage / 100)

        const rounded = calcPartialPrice.toFixed(2)
        setPartialPrice(rounded)
      }
    }
  }

  const handleSinglePrice = (amount, type) => {
    if (singleExperience.seasons && singleExperience.seasons.length) {
      const checkIfDateIsSeason = singleExperience.seasons.filter((item) =>
        checkDateIsBetweenRange(
          formatDateToDB(singleDate),
          item.startDate,
          item.endDate,
        ),
      )

      if (checkIfDateIsSeason.length) {
        let adultPrice = 0,
          childPrice = 0,
          addonTotalPrice = 0
        if (type === 'adult') {
          //Calcular precio de Addons
          const addonPriceArray = selectedAddons
            .filter((item) => item.selected && !item.isSpecial)
            .map((item) => item.price)
          const addonAddArray = addArrayItems(addonPriceArray)
          const totalGuest =
            type === 'adult' ? amount + childAmount : amount + guestAmount
          addonTotalPrice = addonAddArray * totalGuest
          setAddonsPrice(addonTotalPrice)

          //Calcular precio de la reserva mas Addons
          adultPrice = amount * checkIfDateIsSeason[0].adultPrice
          childPrice = childAmount * checkIfDateIsSeason[0].childPrice

          setReservationPrice(adultPrice + childPrice)
          setTotalPrice(adultPrice + childPrice + addonTotalPrice)

          if (singleExperience.isPartialCharge) {
            setPartialPrice(
              (adultPrice + childPrice + addonTotalPrice) *
                (singleExperience.partialPercentage / 100),
            )
          }
        } else {
          //Calcular precio de Addons
          const addonPriceArray = selectedAddons
            .filter((item) => item.selected && !item.isSpecial)
            .map((item) => item.price)
          const addonAddArray = addArrayItems(addonPriceArray)
          const totalGuest =
            type === 'adult' ? amount + childAmount : amount + guestAmount
          addonTotalPrice = addonAddArray * totalGuest
          setAddonsPrice(addonTotalPrice)

          //Calcular precio de la reserva mas Addons
          adultPrice = guestAmount * checkIfDateIsSeason[0].adultPrice
          childPrice = amount * singleExperience.valuePerChild
          setReservationPrice(childPrice + adultPrice)
          setTotalPrice(adultPrice + childPrice + addonTotalPrice)
        }
      } else {
        let adultPrice = 0,
          childPrice = 0,
          addonTotalPrice = 0
        if (type === 'adult') {
          //Calcular precio de Addons
          const addonPriceArray = selectedAddons
            .filter((item) => item.selected && !item.isSpecial)
            .map((item) => item.price)
          const addonAddArray = addArrayItems(addonPriceArray)
          const totalGuest =
            type === 'adult' ? amount + childAmount : amount + guestAmount
          addonTotalPrice = addonAddArray * totalGuest
          setAddonsPrice(addonTotalPrice)

          //Calcular precio de la reserva mas Addons
          adultPrice = amount * singleExperience.valuePerPerson
          childPrice = childAmount * singleExperience.valuePerChild
          setReservationPrice(adultPrice + childPrice)
          setTotalPrice(adultPrice + childPrice + addonTotalPrice)

          if (singleExperience.isPartialCharge) {
            setPartialPrice(
              (adultPrice + childPrice + addonTotalPrice) *
                (singleExperience.partialPercentage / 100),
            )
          }
        } else {
          //Calcular precio de Addons
          const addonPriceArray = selectedAddons
            .filter((item) => item.selected && !item.isSpecial)
            .map((item) => item.price)
          const addonAddArray = addArrayItems(addonPriceArray)
          const totalGuest =
            type === 'adult' ? amount + childAmount : amount + guestAmount
          addonTotalPrice = addonAddArray * totalGuest
          setAddonsPrice(addonTotalPrice)

          //Calcular precio de la reserva mas Addons
          childPrice = amount * singleExperience.valuePerChild
          adultPrice = guestAmount * singleExperience.valuePerPerson
          setReservationPrice(childPrice + adultPrice)
          setTotalPrice(adultPrice + childPrice + addonTotalPrice)
        }
      }
    } else {
      let adultPrice = 0,
        childPrice = 0,
        addonTotalPrice = 0
      if (type === 'adult') {
        const addonPriceArray = selectedAddons
          .filter((item) => item.selected && !item.isSpecial)
          .map((item) => item.price)
        const addonAddArray = addArrayItems(addonPriceArray)
        const totalGuest =
          type === 'adult' ? amount + childAmount : amount + guestAmount
        addonTotalPrice = addonAddArray * totalGuest
        setAddonsPrice(addonTotalPrice)

        if (
          singleExperience?.priceQuantity?.length > 0 &&
          singleExperience.type === 'PXQ' &&
          !resultPxq
        ) {
          const pricesQuantity = singleExperience.priceQuantity
          const index = pricesQuantity.findIndex(
            (x) => x.from <= amount && x.to >= amount,
          )

          adultPrice =
            amount *
            pricesQuantity[index !== -1 ? index : pricesQuantity.length - 1]
              .price
        } else if (
          singleExperience?.pricePerHour?.length > 0 &&
          singleExperience.type === 'PXH'
        ) {
          const pricesQuantity = singleExperience.pricePerHour
          const index = pricesQuantity.findIndex(
            (x) => x.from <= amount && x.to >= amount,
          )

          adultPrice =
            amount *
            pricesQuantity[index !== -1 ? index : pricesQuantity.length - 1]
              .price
        } else {
          adultPrice = amount * singleExperience.valuePerPerson
        }

        childPrice = childAmount * singleExperience.valuePerChild

        setReservationPrice(adultPrice + childPrice)

        setTotalPrice(adultPrice + childPrice + addonTotalPrice)

        if (singleExperience.isPartialCharge) {
          setPartialPrice(
            (adultPrice + childPrice + addonTotalPrice) *
              (singleExperience.partialPercentage / 100),
          )
        }
      } else {
        const addonPriceArray = selectedAddons
          .filter((item) => item.selected && !item.isSpecial)
          .map((item) => item.price)
        const addonAddArray = addArrayItems(addonPriceArray)
        const totalGuest =
          type === 'adult' ? amount + childAmount : amount + guestAmount
        addonTotalPrice = addonAddArray * totalGuest
        setAddonsPrice(addonTotalPrice)

        childPrice = amount * singleExperience.valuePerChild
        adultPrice = guestAmount * singleExperience.valuePerPerson
        setReservationPrice(childPrice + adultPrice)
        setTotalPrice(adultPrice + childPrice + addonTotalPrice)
      }
    }
  }

  const getServicesBlockeds = async () => {
    const response = await firebaseDb
      .collection(
        `agency/${agency.key}/experiences/${singleExperience.key}/services`,
      )
      .where('isBlocked', '==', true)
      .get()

    const services = []
    response.forEach((r) => {
      services.push({ id: r.id, ...r.data() })
    })
    setServicesBlockeds(services)
    setIsServicesBlocked(services.length > 0)
  }

  function validPreviousDays() {
    const previousDays = singleExperience.previousDays
    const dateToday = new Date()
    dateToday.setHours(0, 0, 0, 0) // Establece la hora a las 00:00:00 para ignorar las diferencias de hora
    const dateSelected = new Date(selectedDate)
    dateSelected.setHours(0, 0, 0, 0)

    const timeDifference = dateSelected - dateToday // Diferencia en milisegundos
    const daysDifference = Math.floor(timeDifference / (24 * 60 * 60 * 1000)) // Diferencia en días

    if (previousDays > daysDifference) {
      setOpenSnackBarMinDays(true)
      return false
    } else if (previousDays <= daysDifference) {
      return true
    }
  }

  function ifGiftCardDate() {
    const date = new Date()
    setSelectedDate(date)
    handleDateAndTime(schedule, date)
    setSingleDate(new Date(date))
    setIsErrorSingleDate(false)
    setReservationPrice(0)
    handleGuestAmount(0, 'adult')
    setChildAmount(0)
    setTotalPrice(0)
    resetSelectedAddons()
    setAddonsPersonsPrice(0)
  }

  function ifGiftCardTime() {
    setTime('12:00AM')
    setIsErrorTime(false)
    setIsServiceBlocked(false)
  }

  // function TabPanel(props) {
  //   const { children, value, index, ...other } = props

  //   return (
  //     <div
  //       role="tabpanel"
  //       hidden={value !== index}
  //       id={`simple-tabpanel-${index}`}
  //       aria-labelledby={`simple-tab-${index}`}
  //       {...other}
  //     >
  //       {value === index && (
  //         <Box p={3}>
  //           <Typography>{children}</Typography>
  //         </Box>
  //       )}
  //     </div>
  //   )
  // }

  // TabPanel.propTypes = {
  //   children: PropTypes.node,
  //   index: PropTypes.any.isRequired,
  //   value: PropTypes.any.isRequired,
  // }

  // function a11yProps(index) {
  //   return {
  //     id: `full-width-tab-${index}`,
  //     'aria-controls': `full-width-tabpanel-${index}`,
  //   }
  // }

  const tabClick = (key) => {
    if (key === 'tab1') {
      const dateInitExp = new Date(singleExperience.dateInit)
      const actualDate = new Date()
      if (dateInitExp > actualDate) {
        const date = dateInitExp
        date.setDate(dateInitExp.getDate())
        setSingleDate(date)
        setSelectedDate(date)
      } else if (dateInitExp <= actualDate) {
        const date = new Date()
        if (singleExperience.previousDays) {
          const datePrev = new Date()
          datePrev.setDate(datePrev.getDate() + singleExperience.previousDays)
          setSingleDate(datePrev)
          setSelectedDate(datePrev)
        }
        // } else {
        //   setSingleDate(date)
        //   setSelectedDate(date)
        // }
      }

      handleGuestAmount(0, 'adult')
      setTime('')
      setIsDisableTime(true)
      setIsGiftCard(false)
    } else {
      setIsGiftCard(true)
      ifGiftCardDate()
      ifGiftCardTime()
    }
  }

  const [value, setValue] = React.useState(0)

  const handleChange = (event, newValue) => {
    setValue(newValue)
  }
  const slotProps = {
    fontFamily: 'Muli, sans-serif',
  }

  const onKeyDown = (e) => {
    e.preventDefault()
  }
  const dateFormat = 'MM/DD/YYYY'

  // const generateUniqueKeys = (data) => {
  //   const uniqueKeyMap = new Map();
  //   return data.map((item) => {
  //     const key = item.value; // Usar el valor como clave única
  //     let uniqueKey = key;
  //     let counter = 2;
  //     // Verificar si la clave ya existe en el mapa
  //     while (uniqueKeyMap.has(uniqueKey)) {
  //       uniqueKey = key + counter; // Agregar un número al final para hacer la clave única
  //       counter++;
  //     }
  //     uniqueKeyMap.set(uniqueKey, true); // Agregar la clave al mapa para evitar duplicados
  //     return { ...item, key: uniqueKey }; // Agregar la clave al elemento y devolverlo
  //   });
  // };

  const allPxqData = [
    {
      key: 'pxqTab',
      label: 'Tabla de precios por cantidad de personas',
      children:
        singleExperience && singleExperience?.priceQuantity
          ? singleExperience.priceQuantity
              .slice() // Hacemos una copia del array para no modificar el original
              .sort((a, b) => a.from - b.from) // Ordenamos de menor a mayor por pxq.from
              .map((pxq, i) => {
                return (
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                      marginBottom: '-3%',
                    }}
                    key={i}
                  >
                    <p>
                      De {pxq.from} a {pxq.to} persona(s)
                    </p>
                    <CurrencyFormat
                      value={pxq.price}
                      displayType="text"
                      thousandSeparator
                      prefix="$"
                    />
                  </div>
                )
              })
          : null,
    },
  ]
  const allPxhData = [
    {
      key: 'pxhTab',
      label: 'Tabla de precios por cantidad de horas',
      children:
        singleExperience && singleExperience?.pricePerHour
          ? singleExperience.pricePerHour
              .slice() // Hacemos una copia del array para no modificar el original
              .sort((a, b) => a.from - b.from) // Ordenamos de menor a mayor por pxq.from
              .map((pxh, i) => {
                return (
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                      marginBottom: '-3%',
                    }}
                    key={i}
                  >
                    <p>
                      De {pxh.from} a {pxh.to} hora(s)
                    </p>
                    <CurrencyFormat
                      value={pxh.price}
                      displayType="text"
                      thousandSeparator
                      prefix="$"
                    />
                    <p>Fin de semana</p>
                    <CurrencyFormat
                      value={pxh.weekendPrice}
                      displayType="text"
                      thousandSeparator
                      prefix="$"
                    />
                  </div>
                )
              })
          : null,
    },
  ]

  const items = [
    {
      key: 'tab1',
      label: 'RESERVA',
      children: (
        <div
          className="container-checkout"
          style={{
            display: 'flex',
            flexWrap: 'wrap',
            boxSizing: 'border-box',
            marginTop: '12px',
          }}
          // className="spacer"
        >
          <Row
            gutter={16}
            className="grid-reserva-step1"
            style={{ width: '100% !important' }}
          >
            {singleExperience.seasons &&
              singleExperience.seasons.map((item) => (
                <>
                  <Row
                    gutter={16}
                    style={{ width: '90%', marginTop: '2%', margin: 'auto' }}
                    key={item.name}
                  >
                    <Col xs={24}>
                      <AntdAlert
                        message={
                          <>
                            <Row gutter={16}>
                              <Col xs={12}>
                                <p style={{ margin: 0 }}>
                                  Temporada: {item.name}
                                </p>
                                <p style={{ margin: 0 }}>
                                  Incremento:
                                  <CurrencyFormat
                                    value={item.increase}
                                    displayType="text"
                                    thousandSeparator
                                    prefix="$"
                                  />
                                </p>
                              </Col>
                              <Col xs={12} style={{ textAlign: 'right' }}>
                                <p style={{ margin: 0 }}>
                                  Comienzo:
                                  {formatDBDate(item.startDate)}
                                </p>
                                <p style={{ margin: 0 }}>
                                  Final:
                                  {formatDBDate(item.endDate)}
                                </p>
                              </Col>
                            </Row>
                          </>
                        }
                        type="info"
                        showIcon
                      />
                    </Col>
                  </Row>
                </>
              ))}
            {isExperiencesEnded && (
              <Snackbar
                open={openSnackBar}
                autoHideDuration={6000}
                onClose={() => setOpenSnackBar(false)}
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
              >
                <Alert onClose={() => setOpenSnackBar(false)} severity="info">
                  Esta experiencia ha culminado
                </Alert>
              </Snackbar>
            )}
            {isAvailableCapacity && (
              <Snackbar
                open={openSnackBarCapacity}
                autoHideDuration={6000}
                onClose={() => {
                  setIsAvailableCapacity(false)
                  setOpenSnackBarCapacity(false)
                }}
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
              >
                {singleExperience.type === 'GROUP' ? (
                  <Alert
                    onClose={() => {
                      setIsAvailableCapacity(false)
                      setOpenSnackBarCapacity(false)
                    }}
                    severity="error"
                  >
                    El día y hora seleccionados no poseen capacidad
                  </Alert>
                ) : (
                  <Alert
                    onClose={() => {
                      setIsAvailableCapacity(false)
                      setOpenSnackBarCapacity(false)
                    }}
                    severity="error"
                  >
                    La disponibilidad en el día y hora seleccionados, es menor a
                    la cantidad de participantes
                  </Alert>
                )}
              </Snackbar>
            )}
            <Col
              span={window.innerWidth >= 992 ? 8 : 24}
              className="datepicker-step1"
            >
              <Form.Item
                label={(() => {
                  if (!singleExperience.minPassengers) {
                    return 'Participantes'
                  } else if (singleExperience.minPassengers > 0) {
                    return `Participantes (${singleExperience.minPassengers} o más)`
                  }
                })()}
                className="itemColon"
                colon={false}
                labelCol={{ span: 24 }}
              >
                <InputNumber
                  defaultValue={0}
                  min={
                    singleExperience.minPassengers >= 1
                      ? singleExperience.minPassengers
                      : 0
                  }
                  disabled={guestIsDisable()}
                  size="middle"
                  onKeyUp={handleKeyPress}
                  status={isErrorGuestAmount ? 'error' : null}
                  required
                  value={guestAmount}
                  onChange={(value) => {
                    if (value === null || value === undefined || value === '') {
                      value = 0
                    }
                    handleGuestAmount(value, 'adult')
                    setSingleDate('')
                    setSelectedDate('')
                    setTime('')
                  }}
                  // onKeyDown={handleKeyDown}
                  className="inputnumber"
                />
              </Form.Item>
            </Col>
          </Row>

          {
            <Row
              gutter={16}
              className="grid-reserva-step1"
              style={{ width: '100% !important' }}
            >
              <Col
                span={window.innerWidth >= 992 ? 8 : 24}
                className="datepicker-step1"
              >
                <Form.Item
                  label="Fecha"
                  labelCol={{ span: 24 }}
                  className="itemColon"
                  colon={false}
                >
                  <DatePicker
                    className="picker"
                    format={dateFormat}
                    timeZone="GMT-3"
                    disabled={
                      singleExperience.isPartialCharge &&
                      singleExperience.partialPercentage === 0 &&
                      hotDeal
                        ? null
                        : isExperiencesEnded || guestAmount === 0
                        ? true
                        : false
                    }
                    status={
                      isErrorSingleDate && isPreviousDaysOk ? 'error' : null
                    }
                    placeholder="Seleccione un día"
                    size="middle"
                    value={selectedDate ? dayjs(selectedDate) : null}
                    onChange={(date) => {
                      specificDatesTimeSelect(date ? date.toDate() : null)
                      setSelectedDate(date ? date.toDate() : null)
                      const actualDateReservation = new Date(date.toDate())
                      const nextDate = new Date(actualDateReservation)
                      nextDate.setDate(actualDateReservation.getDate() + 1)
                      handleDateAndTimeExit(schedule, nextDate)
                      handleDateAndTime(schedule, date ? date.toDate() : null)
                      setSingleDate(date ? date.toDate() : null)
                      setIsErrorSingleDate(false)
                      setTime()
                      setExitTime()
                      setExitTimeVisualiz()
                      setTimeVisualiz()
                      // setReservationPrice(0)
                      // setGuestAmount(0)
                      // setChildAmount(0)
                      // setTotalPrice(0)
                      // resetSelectedAddons()
                      // setAddonsPersonsPrice(0)
                      setDay(date ? date.toDate() : null)
                      verifySeasons(date.toDate())
                      getAvailabilityAndFilterHours(date.toDate())
                    }}
                    onKeyUp={handleKeyPress}
                    allowClear={{ clearIcon: null }}
                    onOpenChange={handleOpenChange}
                    onPanelChange={handlePanelChange}
                    disabledDate={(date) => {
                      const currentDate = dayjs()
                      const minDate = handleMinDate()
                      const maxDate = handleMaxDate()
                      const dateString = date.format('YYYY-MM-DD')
                      // matchingReservationsPerDate()
                      // resultsArray.forEach((isAvailable, index) => {
                      //   if (isAvailable) {
                      //     return false
                      //     // Realizar acciones específicas cuando la fecha está disponible
                      //   } else {
                      //     return true
                      //     // Realizar acciones específicas cuando la fecha no está disponible
                      //   }
                      // })

                      if (minDate && date < minDate) {
                        return true
                      }

                      if (maxDate && date > maxDate) {
                        return true
                      }

                      // if (prevDays.includes(dateString)) {
                      //   return true
                      // }

                      return filterDates(date)
                    }}
                  />
                </Form.Item>
              </Col>
              <Col
                span={window.innerWidth >= 992 ? 8 : 24}
                className="label-hr-r-step1"
              >
                <Form.Item
                  label="Horario de entrada"
                  labelCol={{ span: 24 }}
                  className="itemColon"
                  colon={false}
                >
                  <TreeSelect
                    className="picker"
                    style={{ width: '100% !important' }}
                    placeholder="Seleccione un horario"
                    onKeyUp={handleKeyPress}
                    status={!isDisableTime && isErrorTime ? 'error' : null}
                    id="select-time"
                    size="middle"
                    value={timeVisualiz}
                    treeData={treeData}
                    onChange={(value) => {
                      convertTo24HourFormat(value)
                      setTimeVisualiz(value)
                      setIsErrorTime(false)
                      validateServiceHour(value)
                      setIsServiceBlocked(false)

                      //  selectMaxPassengers(value)
                    }}
                    treeDefaultExpandAll
                    disabled={
                      singleExperience.isPartialCharge &&
                      singleExperience.partialPercentage === 0 &&
                      hotDeal
                        ? null
                        : isDisableTime
                    }
                  />
                </Form.Item>
              </Col>
            </Row>
          }
          <Row
            gutter={16}
            className="grid-reserva-step1"
            style={{ width: '100% !important' }}
          >
            <Col
              span={window.innerWidth >= 992 ? 8 : 24}
              className="datepicker-step1"
            >
              <Form.Item
                label="Horario de salida"
                labelCol={{ span: 24 }}
                className="itemColon"
                colon={false}
              >
                <TreeSelect
                  onTreeLoad={dataTimeExitSelect()}
                  className="picker"
                  style={{ width: '100% !important' }}
                  placeholder="Seleccione un horario"
                  onKeyUp={handleKeyPress}
                  status={!isDisableTime && isErrorTime ? 'error' : null}
                  id="select-time"
                  size="middle"
                  value={exitTimeVisualiz}
                  treeData={treeDataExit}
                  onChange={(value) => {
                    convertTo24HourFormatExit(value)
                    setExitTimeVisualiz(value)
                    setIsErrorTime(false)
                    validateServiceHour(value)
                    setIsServiceBlocked(false)
                    calcularTotalHoras(timeVisualiz, value)

                    //  selectMaxPassengers(value)
                  }}
                  treeDefaultExpandAll
                  disabled={time ? false : true}
                />
              </Form.Item>
            </Col>

            <Col
              span={window.innerWidth >= 992 ? 8 : 24}
              className="label-hr-r-step1"
            >
              <Form.Item
                label="Personas extras"
                colon={false}
                labelCol={{ span: 24 }}
                className="itemColon"
              >
                <InputNumber
                  defaultValue={0}
                  min={0}
                  max={4}
                  style={{ margin: 'auto', width: '100%' }}
                  disabled={!timeVisualiz & !exitTimeVisualiz}
                  onKeyUp={handleKeyPress}
                  status={isErrorGuestAmount ? 'error' : null}
                  required
                  value={extraPersons}
                  onChange={(value) => {
                    // Verifica si value es un número válido, si no, establece 0
                    if (value === null || value === undefined || value === '') {
                      value = 0
                    }
                    setExtraPersons(value)
                  }}
                  className="inputnumber"
                />
              </Form.Item>
            </Col>
          </Row>
          {isServiceBlocked && (
            <Grid item xs={12}>
              <Alert severity="error" className="alertBlock">
                El servicio se encuentra bloqueado para esta fecha, por favor
                selecciona otra
              </Alert>
            </Grid>
          )}

          {singleExperience.isPartialCharge &&
          singleExperience.partialPercentage !== 0 ? (
            <Grid item xs={12}>
              <Alert severity="warning" icon={false}>
                Tipo de pago parcial (Inicial{' '}
                <span style={{ fontWeight: 'bold' }}>
                  {singleExperience.partialPercentage}% -{' '}
                  {100 - singleExperience.partialPercentage}%
                </span>{' '}
                Restante )
              </Alert>
            </Grid>
          ) : hotDeal &&
            singleExperience.isPartialCharge &&
            singleExperience.partialPercentage ===
              0 ? null : singleExperience.isPartialCharge &&
            singleExperience.partialPercentage === 0 ? (
            <Grid item xs={12}>
              <Alert severity="warning" icon={false}>
                Con esta pre reserva se espera una confirmación del proveedor
                para realizar el pago
              </Alert>
            </Grid>
          ) : null}

          {singleExperience.type === 'PXQ' &&
            !resultPxq &&
            !!singleExperience?.priceQuantity && (
              <Row
                gutter={16}
                style={{ width: '90%', margin: 'auto', marginTop: '2%' }}
              >
                <Col span={24}>
                  <Collapse
                    size="small"
                    items={allPxqData}
                    expandIconPosition="end"
                    style={{ width: '100%' }}
                  />
                </Col>
              </Row>
            )}
          {singleExperience.type === 'PXH' &&
            !!singleExperience?.pricePerHour && (
              <Row
                gutter={16}
                style={{ width: '90%', margin: 'auto', marginTop: '2%' }}
              >
                <Col span={24}>
                  <Collapse
                    size="small"
                    items={allPxhData}
                    expandIconPosition="end"
                    style={{ width: '100%' }}
                  />
                </Col>
              </Row>
            )}

          <Row gutter={16} style={{ width: '100%', padding: '4%' }}>
            {selectedAddons && selectedAddons.length > 0 ? (
              <Col span={24} style={{ width: '100%' }}>
                <p
                  style={{ margin: 0, fontWeight: 'bold' }}
                  className={classes.fontQuicksand}
                >
                  Servicios Adicionales
                </p>
                {selectedAddons.map((addon, index) => (
                  <Row
                    gutter={16}
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      width: '100%',
                      margin: '0',
                    }}
                    key={addon.key}
                    className={classes.fontMuli}
                  >
                    <Col
                      span={12} // Controla la mitad izquierda del espacio disponible
                      style={{
                        display: 'flex',
                        margin: '0',
                        alignItems: 'center',
                      }}
                    >
                      <Checkbox
                        checked={addon.selected}
                        onChange={(e) =>
                          addon.isSpecial
                            ? handleAddonsSpecial(
                                e.target.checked,
                                addon,
                                index,
                              )
                            : handleAddons(e.target.checked, addon, index)
                        }
                      />
                      <small
                        style={{
                          textTransform: 'capitalize',
                          marginLeft: '1%',
                        }}
                      >
                        {addon.name}
                      </small>
                    </Col>
                    <Col
                      span={12} // Controla la mitad derecha del espacio disponible
                      style={{
                        display: 'flex',
                        margin: '0',
                        alignItems: 'center',
                        justifyContent: 'flex-end', // Alinea el contenido a la derecha
                      }}
                    >
                      {addon.isSpecial && (
                        <div
                          style={{
                            width: '100%',

                            display: 'flex',
                            justifyContent: 'space-between',
                          }}
                        >
                          <InputNumber
                            disabled={!addon.selected}
                            defaultValue={1}
                            style={{
                              marginLeft: '5px',
                              width: '50px',
                              height: '30px',
                              justifyContent: 'center',
                            }}
                            // value={!!addon.quantity ? addon.quantity : 0}
                            min={1}
                            onChange={(value) =>
                              handleChangeQty(parseInt(value), addon, index)
                            }
                          />
                          <small>
                            <CurrencyFormat
                              value={addon.price}
                              displayType="text"
                              thousandSeparator
                              prefix="$"
                            />
                            {addon.isSpecial && '/un'}
                          </small>
                        </div>
                      )}

                      {!addon.isSpecial && (
                        <>
                          <small>
                            <CurrencyFormat
                              value={addon.price}
                              displayType="text"
                              thousandSeparator
                              prefix="$"
                            />
                          </small>
                        </>
                      )}
                    </Col>
                  </Row>
                ))}
              </Col>
            ) : null}

            <Row gutter={16} style={{ width: '100%' }}>
              <hr className="hr-style" />

              {/* {singleExperience.isPartialCharge &&
              singleExperience.partialPercentage === 0 &&
              !hotDeal ? null : (
                <Col
                  style={{
                    display: 'flex',
                    margin: 'auto',
                    paddingTop: '2%',
                    justifyContent: 'space-between',
                    width: '100%',
                    marginLeft: '2%',
                  }}
                  className={classes.fontQuicksand}
                >
                  Precio por Persona{' '}
                  <CurrencyFormat
                    value={
                      singleExperience.seasons &&
                      singleExperience.seasons.length >= 1
                        ? singleExperience.seasons[0].adultPrice
                        : singleExperience.valuePerPerson
                    }
                    displayType="text"
                    thousandSeparator
                    prefix="$"
                  />
                </Col>
              )} */}
              {extraPersons > 0 ? (
                <Col
                  style={{
                    display: 'flex',
                    margin: 'auto',
                    paddingTop: '2%',
                    justifyContent: 'space-between',
                    width: '100%',
                    marginLeft: '2%',
                  }}
                  className={classes.fontQuicksand}
                >
                  Personas extra{' '}
                  <CurrencyFormat
                    value={(reservationPrice / 2) * extraPersons}
                    displayType="text"
                    thousandSeparator
                    prefix="$"
                  />
                </Col>
              ) : null}

              {onSeasons?.isActive ? (
                <Col
                  style={{
                    display: 'flex',
                    margin: 'auto',
                    paddingTop: '2%',
                    justifyContent: 'space-between',
                    width: '100%',
                    marginLeft: '2%',
                  }}
                  className={classes.fontQuicksand}
                >
                  Incremento por hora (temporada){' '}
                  <CurrencyFormat
                    value={onSeasons.increase}
                    displayType="text"
                    thousandSeparator
                    prefix="$"
                  />
                </Col>
              ) : null}

              {selectedAddons && selectedAddons.length > 0 ? (
                <Col
                  style={{
                    display: 'flex',
                    margin: 'auto',
                    paddingTop: '2%',
                    justifyContent: 'space-between',
                    width: '100%',
                    marginLeft: '2%',
                  }}
                  className={classes.fontQuicksand}
                >
                  Adicionales{' '}
                  <CurrencyFormat
                    value={addonsPrice ? addonsPrice : 0}
                    displayType="text"
                    thousandSeparator
                    prefix="$"
                  />
                </Col>
              ) : null}

              {selectedAddons && selectedAddons.length > 0 ? (
                <Col
                  style={{
                    display: 'flex',
                    margin: 'auto',
                    paddingTop: '2%',
                    justifyContent: 'space-between',
                    marginLeft: '2%',

                    width: '100%',
                  }}
                  className={classes.fontQuicksand}
                >
                  Adicionales por persona{' '}
                  <CurrencyFormat
                    value={addonsPersonsPrice}
                    displayType="text"
                    thousandSeparator
                    prefix="$"
                  />
                </Col>
              ) : null}

              <hr className="hr-style" />
              {singleExperience.isPartialCharge &&
              singleExperience.partialPercentage === 0 ? null : (
                <Col
                  style={{
                    display: 'flex',
                    margin: 'auto',
                    paddingTop: '2%',
                    justifyContent: 'space-between',
                    marginLeft: '2%',

                    width: '100%',
                  }}
                  className={classes.fontQuicksand}
                >
                  Reserva{' '}
                  <CurrencyFormat
                    value={
                      !!reservationPrice
                        ? reservationPrice +
                          addonsPrice +
                          addonsPersonsPrice +
                          ((reservationPrice +
                            addonsPrice +
                            addonsPersonsPrice) /
                            2) *
                            extraPersons
                        : 0
                    }
                    displayType="text"
                    thousandSeparator
                    prefix="$"
                  />
                </Col>
              )}
            </Row>

            {singleExperience.isPartialCharge &&
            singleExperience.partialPercentage === 0 &&
            hotDeal ? (
              <p
                style={{
                  fontWeight: 'bold',
                  display: 'flex',
                  justifyContent: 'center',
                  alignContent: 'center',
                  margin: 'auto',
                }}
              >
                <Tooltip title="Usted realizará el pago de su pre-reserva">
                  <InfoIcon style={{ fontSize: '20px' }} />
                </Tooltip>
                <span style={{}}>{`Pago diferido`}</span>
              </p>
            ) : singleExperience.isPartialCharge &&
              singleExperience.partialPercentage === 0 ? (
              <p
                style={{
                  fontWeight: 'bold',
                  display: 'flex',
                  justifyContent: 'center',
                  alignContent: 'center',
                  margin: 'auto',
                }}
              >
                <Tooltip title="Usted realizará una pre-reserva, cuando el proveedor confirme la misma, se le avisará para que efectúe el pago correspondiente">
                  <InfoIcon style={{ fontSize: '20px' }} />
                </Tooltip>
                <span style={{}}>{`Pago diferido`}</span>
              </p>
            ) : singleExperience.isPartialCharge &&
              singleExperience.partialPercentage !== 0 ? (
              <p
                style={{
                  fontWeight: 'bold',
                  display: 'flex',
                  justifyContent: 'flex-end',
                  alignContent: 'center',
                  margin: 'auto',
                }}
              >
                <Tooltip title="Es la primera parte del cobro al realizar una reserva, el porcentaje restante será cobrado una vez se haga check-in el dia de la reserva">
                  <InfoIcon style={{ fontSize: '20px' }} />
                </Tooltip>
                <span
                  style={{ marginRight: '5px', marginLeft: '5px' }}
                >{`Pago Parcial Inicial (${singleExperience.partialPercentage}%): `}</span>

                <CurrencyFormat
                  value={
                    ((!!reservationPrice
                      ? reservationPrice + addonsPrice + addonsPersonsPrice
                      : 0) *
                      singleExperience.partialPercentage) /
                    100
                  }
                  displayType="text"
                  thousandSeparator
                  prefix="$"
                />
              </p>
            ) : null}
          </Row>

          <Space
            style={{ width: '100%', marginTop: '2%', justifyContent: 'center' }}
          >
            <Button
              disabled={isExperiencesEnded}
              variant="contained"
              onClick={validateForm}
              className="btn"
            >
              Continuar
            </Button>
          </Space>
        </div>
      ),
    },
    (singleExperience.isPartialCharge &&
      singleExperience.partialPercentage === 0) ||
    singleExperience.giftCardIsActive === false
      ? null
      : {
          key: 'tab2',
          label: 'GIFT CARD',
          children: (
            <div
              style={{
                display: 'flex',
                flexWrap: 'wrap',
                boxSizing: 'border-box',
              }}
              className="spacer"
            >
              {timedBlockersAlert}
              {giftCard && (
                <Row gutter={16} style={{ width: '100%', marginTop: '2%' }}>
                  <Col xs={24}>
                    <AntdAlert
                      message=" La cantidad máxima de participantes para la compra de una Gift
              Card es de 2 personas!"
                      type="info"
                      showIcon
                    />
                  </Col>
                </Row>
              )}

              {isPreviousDaysOk && (
                <Row gutter={16} style={{ width: '90%', marginTop: '2%' }}>
                  <Col xs={24}>
                    <AntdAlert
                      message={`Esta experiencia necesita reservarse con ${singleExperience.previousDays} de anticipación`}
                      type="info"
                      showIcon
                    />
                  </Col>
                </Row>
              )}
              {singleExperience.seasons &&
                singleExperience.seasons.map((item) => (
                  <>
                    <Row
                      gutter={16}
                      style={{ width: '90%', marginTop: '2%' }}
                      key={item.name}
                    >
                      <Col xs={24}>
                        <AntdAlert
                          message={
                            <>
                              <Row gutter={16}>
                                <Col xs={12}>
                                  <p style={{ margin: 0 }}>
                                    Temporada: {item.name}
                                  </p>
                                  <p style={{ margin: 0 }}>
                                    Incremento:
                                    <CurrencyFormat
                                      value={item.increase}
                                      displayType="text"
                                      thousandSeparator
                                      prefix="$"
                                    />
                                  </p>
                                </Col>
                                <Col xs={12} style={{ textAlign: 'right' }}>
                                  <p style={{ margin: 0 }}>
                                    Comienzo:
                                    {formatDBDate(item.startDate)}
                                  </p>
                                  <p style={{ margin: 0 }}>
                                    Final:
                                    {formatDBDate(item.endDate)}
                                  </p>
                                </Col>
                              </Row>
                            </>
                          }
                          type="info"
                          showIcon
                        />
                      </Col>
                    </Row>
                  </>
                ))}
              {isExperiencesEnded && (
                <Snackbar
                  open={openSnackBar}
                  autoHideDuration={6000}
                  onClose={() => setOpenSnackBar(false)}
                  anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                >
                  <Alert onClose={() => setOpenSnackBar(false)} severity="info">
                    Esta experiencia ha culminado
                  </Alert>
                </Snackbar>
              )}
              {isPassengersCapacity && (
                <Snackbar
                  open={openSnackPassengers}
                  autoHideDuration={6000}
                  onClose={() => setOpenSnackPassengers(false)}
                  anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                >
                  <Alert
                    onClose={() => setOpenSnackPassengers(false)}
                    severity="info"
                  >
                    La cantidad máxima de pasajeros es {maxPassengers}
                    {/* No hay capacidad suficiente para los participantes que estás
                seleccionando */}
                  </Alert>
                </Snackbar>
              )}
              {isAvailableCapacity && (
                <Snackbar
                  open={openSnackBarCapacity}
                  autoHideDuration={6000}
                  onClose={() => setOpenSnackBarCapacity(false)}
                  anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                >
                  {singleExperience.type === 'GROUP' ? (
                    <Alert
                      onClose={() => {
                        setIsAvailableCapacity(false)
                        setOpenSnackBarCapacity(false)
                      }}
                      severity="error"
                    >
                      El día y hora seleccionados no poseen capacidad
                    </Alert>
                  ) : (
                    <Alert
                      onClose={() => {
                        setIsAvailableCapacity(false)
                        setOpenSnackBarCapacity(false)
                      }}
                      severity="error"
                    >
                      La disponibilidad en el día y hora seleccionados, es menor
                      a la cantidad de participantes
                    </Alert>
                  )}
                </Snackbar>
              )}

              <Row
                gutter={16}
                className="grid-gift-step"
                style={{ width: '100% !important' }}
              >
                <Col
                  span={window.innerWidth >= 992 ? 8 : 24}
                  className="participantesGift"
                >
                  <Form.Item
                    label=" Participantes"
                    colon={false}
                    labelCol={{ span: 24 }}
                    className="itemColon"
                  >
                    <InputNumber
                      defaultValue={0}
                      min={0}
                      max={2}
                      style={{ margin: 'auto', width: '100%' }}
                      disabled={guestIsDisable()}
                      onKeyUp={handleKeyPress}
                      status={isErrorGuestAmount ? 'error' : null}
                      required
                      value={guestAmount}
                      onChange={(value) => {
                        // Verifica si value es un número válido, si no, establece 0
                        if (
                          value === null ||
                          value === undefined ||
                          value === ''
                        ) {
                          value = 0
                        }
                        handleGuestAmount(value, 'adult')
                      }}
                      className="inputnumber"
                    />
                  </Form.Item>
                </Col>
                {singleExperience.valuePerChild ? (
                  <Col
                    span={window.innerWidth >= 992 ? 8 : 24}
                    className="label-pChild-gift"
                  >
                    <Form.Item
                      label={(() => {
                        if (!singleExperience.kidsAge) {
                          return 'Niños (hasta 12 años)'
                        } else if (singleExperience.kidsAge === 0) {
                          return 'Niños (hasta 12 años)'
                        } else if (singleExperience.kidsAge > 0) {
                          return `Niños (hasta ${singleExperience.kidsAge} años)`
                        }
                      })()}
                      colon={false}
                      labelCol={{ span: 24 }}
                      className="itemColon"
                    >
                      <InputNumber
                        min={0}
                        defaultValue={0}
                        style={{ width: '100%' }}
                        disabled={guestIsDisable()}
                        value={childAmount}
                        onChange={(value) => {
                          if (
                            value === null ||
                            value === undefined ||
                            value === ''
                          ) {
                            value = 0
                          }
                          handleGuestAmount(value, 'child')
                        }}
                        className="inputnumber"
                      />
                    </Form.Item>
                  </Col>
                ) : null}
              </Row>

              {singleExperience.isPartialCharge &&
              singleExperience.partialPercentage !== 0 ? (
                <Grid item xs={12}>
                  <Alert severity="warning" icon={false}>
                    Tipo de pago parcial (Inicial{' '}
                    <span style={{ fontWeight: 'bold' }}>
                      {singleExperience.partialPercentage}% -{' '}
                      {100 - singleExperience.partialPercentage}%
                    </span>{' '}
                    Restante )
                  </Alert>
                </Grid>
              ) : hotDeal &&
                singleExperience.isPartialCharge &&
                singleExperience.partialPercentage ===
                  0 ? null : singleExperience.isPartialCharge &&
                singleExperience.partialPercentage === 0 ? (
                <Grid item xs={12}>
                  <Alert severity="warning" icon={false}>
                    Con esta pre reserva se espera una confirmación del
                    proveedor para realizar el pago
                  </Alert>
                </Grid>
              ) : null}

              {singleExperience.type === 'PXQ' &&
                !resultPxq &&
                !!singleExperience?.priceQuantity && (
                  <Row gutter={16} style={{ width: '100%' }}>
                    <Col span={24}>
                      <Collapse
                        size="small"
                        items={allPxqData}
                        expandIconPosition="end"
                        style={{ width: '100%' }}
                      />
                    </Col>
                  </Row>
                )}

              <Row gutter={16} style={{ width: '100%', padding: '4%' }}>
                {selectedAddons && selectedAddons.length > 0 ? (
                  <Col span={24} style={{ width: '100%' }}>
                    <p
                      style={{ margin: 0, fontWeight: 'bold' }}
                      className={classes.fontQuicksand}
                    >
                      Servicios Adicionales
                    </p>
                    {selectedAddons.map((addon, index) => (
                      <Row
                        gutter={16}
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          width: '100%',
                          margin: '0',
                        }}
                        key={addon.key}
                        className={classes.fontMuli}
                      >
                        <Col
                          span={12} // Controla la mitad izquierda del espacio disponible
                          style={{
                            display: 'flex',
                            margin: '0',
                            alignItems: 'center',
                          }}
                        >
                          <Checkbox
                            checked={addon.selected}
                            onChange={(e) =>
                              addon.isSpecial
                                ? handleAddonsSpecial(
                                    e.target.checked,
                                    addon,
                                    index,
                                  )
                                : handleAddons(e.target.checked, addon, index)
                            }
                          />
                          <small
                            style={{
                              textTransform: 'capitalize',
                              marginLeft: '1%',
                            }}
                          >
                            {addon.name}
                          </small>
                        </Col>
                        <Col
                          span={12} // Controla la mitad derecha del espacio disponible
                          style={{
                            display: 'flex',
                            margin: '0',
                            alignItems: 'center',
                            justifyContent: 'flex-end', // Alinea el contenido a la derecha
                          }}
                        >
                          {addon.isSpecial && (
                            <div
                              style={{
                                width: '100%',

                                display: 'flex',
                                justifyContent: 'space-between',
                              }}
                            >
                              <InputNumber
                                disabled={!addon.selected}
                                defaultValue={1}
                                style={{
                                  marginRight: '10px',
                                  width: '50px',
                                  height: '30px',
                                  justifyContent: 'center',
                                }}
                                // value={!!addon.quantity ? addon.quantity : 0}
                                min={1}
                                onChange={(value) =>
                                  handleChangeQty(parseInt(value), addon, index)
                                }
                              />
                              <small>
                                <CurrencyFormat
                                  value={addon.price}
                                  displayType="text"
                                  thousandSeparator
                                  prefix="$"
                                />
                                {addon.isSpecial && '/un'}
                              </small>
                            </div>
                          )}

                          {!addon.isSpecial && (
                            <>
                              <small>
                                <CurrencyFormat
                                  value={addon.price}
                                  displayType="text"
                                  thousandSeparator
                                  prefix="$"
                                />
                              </small>
                            </>
                          )}
                        </Col>
                      </Row>
                    ))}
                  </Col>
                ) : null}

                <Row gutter={16} style={{ width: '100%' }}>
                  <hr className="hr-style" />

                  {singleExperience.isPartialCharge &&
                  singleExperience.partialPercentage === 0 ? null : (
                    <Col
                      style={{
                        display: 'flex',
                        margin: 'auto',
                        paddingTop: '2%',
                        justifyContent: 'space-between',
                        width: '100%',
                        marginLeft: '2%',
                      }}
                      className={classes.fontQuicksand}
                    >
                      Precio por Persona{' '}
                      <CurrencyFormat
                        value={
                          singleExperience.seasons &&
                          singleExperience.seasons.length >= 1
                            ? singleExperience.seasons[0].adultPrice
                            : singleExperience.valuePerPerson
                        }
                        displayType="text"
                        thousandSeparator
                        prefix="$"
                      />
                    </Col>
                  )}
                  {singleExperience.valuePerChild ? (
                    <Col
                      style={{
                        display: 'flex',
                        margin: 'auto',
                        paddingTop: '2%',
                        justifyContent: 'space-between',
                        width: '100%',
                        marginLeft: '2%',
                      }}
                      className={classes.fontQuicksand}
                    >
                      Precio por niños{' '}
                      <CurrencyFormat
                        value={singleExperience.valuePerChild}
                        displayType="text"
                        thousandSeparator
                        prefix="$"
                      />
                    </Col>
                  ) : null}

                  {selectedAddons && selectedAddons.length > 0 ? (
                    <Col
                      style={{
                        display: 'flex',
                        margin: 'auto',
                        paddingTop: '2%',
                        justifyContent: 'space-between',
                        width: '100%',
                        marginLeft: '2%',
                      }}
                      className={classes.fontQuicksand}
                    >
                      Adicionales{' '}
                      <CurrencyFormat
                        value={addonsPrice ? addonsPrice : 0}
                        displayType="text"
                        thousandSeparator
                        prefix="$"
                      />
                    </Col>
                  ) : null}

                  {selectedAddons && selectedAddons.length > 0 ? (
                    <Col
                      style={{
                        display: 'flex',
                        margin: 'auto',
                        paddingTop: '2%',
                        justifyContent: 'space-between',
                        marginLeft: '2%',

                        width: '100%',
                      }}
                      className={classes.fontQuicksand}
                    >
                      Adicionales por persona{' '}
                      <CurrencyFormat
                        value={addonsPersonsPrice}
                        displayType="text"
                        thousandSeparator
                        prefix="$"
                      />
                    </Col>
                  ) : null}

                  <hr className="hr-style" />
                  {singleExperience.isPartialCharge &&
                  singleExperience.partialPercentage === 0 ? null : (
                    <Col
                      style={{
                        display: 'flex',
                        margin: 'auto',
                        paddingTop: '2%',
                        justifyContent: 'space-between',
                        marginLeft: '2%',

                        width: '100%',
                      }}
                      className={classes.fontQuicksand}
                    >
                      Reserva{' '}
                      <CurrencyFormat
                        value={
                          !!reservationPrice
                            ? reservationPrice +
                              addonsPrice +
                              addonsPersonsPrice
                            : 0
                        }
                        displayType="text"
                        thousandSeparator
                        prefix="$"
                      />
                    </Col>
                  )}
                </Row>

                {singleExperience.isPartialCharge &&
                singleExperience.partialPercentage === 0 &&
                hotDeal ? (
                  <p
                    style={{
                      fontWeight: 'bold',
                      display: 'flex',
                      justifyContent: 'center',
                      alignContent: 'center',
                      margin: 'auto',
                    }}
                  >
                    <Tooltip title="Usted realizará el pago de su pre-reserva">
                      <InfoIcon style={{ fontSize: '20px' }} />
                    </Tooltip>
                    <span style={{}}>{`Pago diferido`}</span>
                  </p>
                ) : singleExperience.isPartialCharge &&
                  singleExperience.partialPercentage === 0 ? (
                  <p
                    style={{
                      fontWeight: 'bold',
                      display: 'flex',
                      justifyContent: 'center',
                      alignContent: 'center',
                      margin: 'auto',
                    }}
                  >
                    <Tooltip title="Usted realizará una pre-reserva, cuando el proveedor confirme la misma, se le avisará para que efectúe el pago correspondiente">
                      <InfoIcon style={{ fontSize: '20px' }} />
                    </Tooltip>
                    <span style={{}}>{`Pago diferido`}</span>
                  </p>
                ) : singleExperience.isPartialCharge &&
                  singleExperience.partialPercentage !== 0 ? (
                  <p
                    style={{
                      fontWeight: 'bold',
                      display: 'flex',
                      justifyContent: 'flex-end',
                      alignContent: 'center',
                      margin: 'auto',
                    }}
                  >
                    <Tooltip title="Es la primera parte del cobro al realizar una reserva, el porcentaje restante será cobrado una vez se haga check-in el dia de la reserva">
                      <InfoIcon style={{ fontSize: '20px' }} />
                    </Tooltip>
                    <span
                      style={{ marginRight: '5px', marginLeft: '5px' }}
                    >{`Pago Parcial Inicial (${singleExperience.partialPercentage}%): `}</span>

                    <CurrencyFormat
                      value={
                        ((!!reservationPrice
                          ? reservationPrice + addonsPrice + addonsPersonsPrice
                          : 0) *
                          singleExperience.partialPercentage) /
                        100
                      }
                      displayType="text"
                      thousandSeparator
                      prefix="$"
                    />
                  </p>
                ) : null}
              </Row>

              <Space
                style={{
                  width: '100%',
                  marginTop: '2%',
                  justifyContent: 'center',
                }}
              >
                <Button
                  style={{ margin: 'auto' }}
                  disabled={isExperiencesEnded}
                  variant="contained"
                  onClick={validateForm}
                  className="btn"
                >
                  Continuar
                </Button>
              </Space>
            </div>
          ),
        },
  ]
  return (
    <Layout style={{ width: '100%' }}>
      <Space>
        <Tabs
          defaultActiveKey="activeKey"
          items={items}
          onChange={handleChange}
          onTabClick={tabClick}
          tabBarStyle={{ textAlign: 'center' }}
        ></Tabs>
      </Space>
    </Layout>
  )
}

export default ReservationDetailsHotelsPerHours
